export const APP_LOADING = "APP_LOADING";
export const USER_FAV = "USER_FAV";
export const USER_UN_FAV = "USER_UN_FAV";
export const LANGUAGE_PREFERRED = "LANGUAGE_PREFERRED";
export const LANGUAGE_DATA = "LANGUAGE_DATA";
export const LANGUAGE_LIST = "LANGUAGE_LIST";
export const LANGUAGE_CURRENT = "LANGUAGE_CURRENT";
export const LOGIN_HARD_BLOCKER = "LOGIN_HARD_BLOCKER";
export const SET_MOBILE_VIEW = "SET_MOBILE_VIEW";
export const HOVERED_ACTIVE_ITEM = "HOVERED_ACTIVE_ITEM";
export const MAIN_CAROUSEL_DATA = "MAIN_CAROUSEL_DATA";
export const SHOW_NAVIGATION_ALERT = "SHOW_NAVIGATION_ALERT";
export const IS_NAVIGATION_ALERT_ACTIVE = "IS_NAVIGATION_ALERT_ACTIVE";
export const SET_LANGUAGES_LIST = "SET_LANGUAGES_LIST";
export const SET_RAW_LANGUAGES_LIST = "SET_RAW_LANGUAGES_LIST";
export const SET_ACTIVE_LANGUAGE = "SET_ACTIVE_LANGUAGE";
export const DASHBOARD_ACTION_GET_NEW_DATA = "DASHBOARD_ACTION_GET_NEW_DATA";
export const CATEGORIES_DASHBOARD_REQUEST = "CATEGORIES_DASHBOARD_REQUEST";
export const CURRICULUM_DASHBOARD_REQUEST = "CURRICULUM_DASHBOARD_REQUEST";
export const SET_USER_PROFILE_DETAILS = "SET_USER_PROFILE_DETAILS";
export const GET_LANGUAGE_LIST_REQUEST = "GET_LANGUAGE_LIST_REQUEST";
export const CURRICULUM_READ_REQUEST = "CURRICULUM_READ_REQUEST";
export const CURRICULUM_HOME_READ_REQUEST = "CURRICULUM_HOME_READ_REQUEST";
//Plans
export const GET_PLANS_REQUEST = "GET_PLANS_REQUEST";
export const SAVE_PLANS_REQUEST = "SAVE_PLANS_REQUEST";
export const UPDATE_PLANS_REQUEST = "UPDATE_PLANS_REQUEST";
export const DELETE_PLANS_REQUEST = "DELETE_PLANS_REQUEST";
export const SAVE_PLAN_THUMBNAIL_REQUEST = "SAVE_PLAN_THUMBNAIL_REQUEST";
export const UPDATE_PLAN_THUMBNAIL_REQUEST = "UPDATE_PLAN_THUMBNAIL_REQUEST";
export const SAVE_PLAN_DAY_REQUEST = "SAVE_PLAN_DAY_REQUEST";
export const UPDATE_PLAN_DAY_REQUEST = "UPDATE_PLAN_DAY_REQUEST";
export const DELETE_PLAN_DAY_REQUEST = "DELETE_PLAN_DAY_REQUEST";
export const SAVE_RELATED_PLANS_REQUEST = "SAVE_RELATED_PLANS_REQUEST";
export const DELETE_RELATED_PLANS_REQUEST = "DELETE_RELATED_PLANS_REQUEST";

export const SAVE_PLAN_CATEGORY_REQUEST = "SAVE_PLAN_CATEGORY_REQUEST";
export const SAVE_PLAN_CATEGORY_SUCCESS = "SAVE_PLAN_CATEGORY_SUCCESS";
export const SAVE_PLAN_CATEGORY_FAILURE = "SAVE_PLAN_CATEGORY_FAILURE";

export const UPDATE_PLAN_CATEGORY_REQUEST = "UPDATE_PLAN_CATEGORY_REQUEST";
export const DELETE_PLAN_CATEGORY_REQUEST = "DELETE_PLAN_CATEGORY_REQUEST";
export const SAVE_CATEGORY_PLAN_REQUEST = "SAVE_CATEGORY_PLAN_REQUEST";
export const DELETE_CATEGORY_PLAN_REQUEST = "DELETE_CATEGORY_PLAN_REQUEST";
//Journal Speaker Action Types
export const GET_SPEAKERS_LIST_REQUEST = "GET_SPEAKERS_LIST_REQUEST";
export const SAVE_SPEAKER_DETAILS_REQUEST = "SAVE_SPEAKER_DETAILS_REQUEST";
export const UPDATE_SPEAKER_DETAILS_REQUEST = "UPDATE_SPEAKER_DETAILS_REQUEST";
export const DELETE_SPEAKER_DETAILS_REQUEST = "DELETE_SPEAKER_DETAILS_REQUEST";
// Journal Language Speaker Action Types
export const SAVE_JOURNAL_LANGUAGE_SPEAKER_REQUEST = "SAVE_JOURNAL_LANGUAGE_SPEAKER_REQUEST";
export const UPDATE_JOURNAL_LANGUAGE_SPEAKER_REQUEST = "UPDATE_JOURNAL_LANGUAGE_SPEAKER_REQUEST";
export const DELETE_JOURNAL_LANGUAGE_SPEAKER_REQUEST = "DELETE_JOURNAL_LANGUAGE_SPEAKER_REQUEST";
// Journal Category Language Action Types
export const SAVE_JOURNAL_LANGUAGE_CATEGORY_REQUEST = "SAVE_JOURNAL_LANGUAGE_CATEGORY_REQUEST";
export const UPDATE_JOURNAL_LANGUAGE_CATEGORY_REQUEST = "UPDATE_JOURNAL_LANGUAGE_CATEGORY_REQUEST";
export const DELETE_JOURNAL_LANGUAGE_CATEGORY_REQUEST = "DELETE_JOURNAL_LANGUAGE_CATEGORY_REQUEST";
// Journal Language
export const SAVE_JOURNAL_LANGUAGE_REQUEST   = "SAVE_JOURNAL_LANGUAGE_REQUEST";
export const UPDATE_JOURNAL_LANGUAGE_REQUEST = "UPDATE_JOURNAL_LANGUAGE_REQUEST";
export const DELETE_JOURNAL_LANGUAGE_REQUEST = "DELETE_JOURNAL_LANGUAGE_REQUEST";

// Journal Language Notes
export const SAVE_JOURNAL_LANGUAGE_NOTES_REQUEST   = "SAVE_JOURNAL_LANGUAGE_NOTES_REQUEST";
export const UPDATE_JOURNAL_LANGUAGE_NOTES_REQUEST = "UPDATE_JOURNAL_LANGUAGE_NOTES_REQUEST";
export const DELETE_JOURNAL_LANGUAGE_NOTES_REQUEST = "DELETE_JOURNAL_LANGUAGE_NOTES_REQUEST";

// Journal Language NoteItems
export const SAVE_JOURNAL_LANGUAGE_NOTEITEMS_REQUEST   = "SAVE_JOURNAL_LANGUAGE_NOTEITEMS_REQUEST";
export const UPDATE_JOURNAL_LANGUAGE_NOTEITEMS_REQUEST = "UPDATE_JOURNAL_LANGUAGE_NOTEITEMS_REQUEST";
export const DELETE_JOURNAL_LANGUAGE_NOTEITEMS_REQUEST = "DELETE_JOURNAL_LANGUAGE_NOTEITEMS_REQUEST";
//Bible
export const SET_BIBLE_VERSION = "SET_BIBLE_VERSION";
export const SET_BIBLE_COUNTRY_LANGUAGES = "SET_BIBLE_COUNTRY_LANGUAGES";
export const SET_BIBLE_LANGUAGE = "SET_BIBLE_LANGUAGE";
export const SET_VERSION_DETAILS = "SET_VERSION_DETAILS";
export const SET_BIBLE_PARALLEL_MODE = "SET_BIBLE_PARALLEL_MODE";
export const SET_BOOK_CHAPTER_DETAILS = "SET_BOOK_CHAPTER_DETAILS";
export const SET_BOOK_CHAPTER_DETAILS_LOADING = "SET_BOOK_CHAPTER_DETAILS_LOADING";
export const SET_PARALLEL_VERSION_DETAILS = "SET_PARALLEL_VERSION_DETAILS";
export const SET_PARALLEL_BOOK_CHAPTER_DETAILS = "SET_PARALLEL_BOOK_CHAPTER_DETAILS";
export const SET_PARALLEL_BOOK_CHAPTER_DETAILS_LOADING =
  "SET_PARALLEL_BOOK_CHAPTER_DETAILS_LOADING";
export const SET_USER_JOURNALS = "SET_USER_JOURNALS";
export const SET_ACTIVE_SEARCH_TAB = "SET_ACTIVE_SEARCH_TAB";
export const SET_ACTIVE_PARALLEL_SEARCH_TAB = "SET_ACTIVE_PARALLEL_SEARCH_TAB";
export const SET_ALL_BIBLE_LANGUAGES = "SET_ALL_BIBLE_LANGUAGES";
export const SET_ALL_BIBLE_VERSIONS = "SET_ALL_BIBLE_VERSIONS";

export const GET_VERSION_BOOKS_REQUEST = "GET_VERSION_BOOKS_REQUEST";
export const GET_BIBLE_VERSIONS_REQUEST = "GET_BIBLE_VERSIONS_REQUEST";
export const GET_BIBLE_LANGUAGES_REQUEST = "GET_BIBLE_LANGUAGES_REQUEST";
export const GET_BIBLE_COUNTRY_LANGUAGES_REQUEST = "GET_BIBLE_COUNTRY_LANGUAGES_REQUEST";
export const GET_BIBLE_CHAPTER_DETAILS = "GET_BIBLE_CHAPTER_DETAILS";
export const GET_BIBLE_SEARCH = "GET_BIBLE_SEARCH";
export const GET_BIBLE_RESOURCE_KEY = "GET_BIBLE_RESOURCE_KEY";
export const GET_USER_JOURNALS = "GET_USER_JOURNALS";
export const DELETE_USER_JOURNALS = "DELETE_USER_JOURNALS";
export const GET_VERSE_DETAILS = "GET_VERSE_DETAILS";
export const SAVE_VERSE_COLOR = "SAVE_VERSE_COLOR";
export const UPDATE_VERSE_COLOR = "UPDATE_VERSE_COLOR";
export const DELETE_VERSE_COLOR = "DELETE_VERSE_COLOR";
export const GET_VERSE_COLOR = "GET_VERSE_COLOR";
export const GET_CHAPTER_VIDEOS = "GET_CHAPTER_VIDEOS";
export const GET_CHAPTER_JOURNALS = "GET_CHAPTER_JOURNALS";
export const GET_JOURNALS = "GET_JOURNALS";
export const UPDATE_USER_STREAK = "UPDATE_USER_STREAK";
export const GET_USER_STREAK_SUMMARY = "GET_USER_STREAK_SUMMARY";
export const GET_JOURNAL_SPEAKERS = "GET_JOURNAL_SPEAKERS";
export const GET_JOURNALS_BY_SPEAKER = "GET_JOURNALS_BY_SPEAKER";
export const GET_JOURNALS_BY_CATEGORY = "GET_JOURNALS_BY_CATEGORY";
export const GET_BIBLE_SUMMARY = "GET_BIBLE_SUMMARY";
export const SET_JOURNALS = "SET_JOURNALS";
export const SET_BIBLE_LANGUAGE_NAME="SET_BIBLE_LANGUAGE_NAME";
export const SET_ALL_JOURNALS="SET_ALL_JOURNALS";
export const SET_VERSION_DETAILS_LOADING="SET_VERSION_DETAILS_LOADING"
// Bible search
export const SET_GLOBAL_BIBLE_SEARCH_RESULTS = "SET_GLOBAL_BIBLE_SEARCH_RESULTS";
export const ADD_GLOBAL_BIBLE_SEARCH_RESULTS = "ADD_GLOBAL_BIBLE_SEARCH_RESULTS";
//journal
export const UPDATE_JOURNAL_REQUEST = "UPDATE_JOURNAL_REQUEST";
export const SAVE_JOURNAL_REQUEST = "SAVE_JOURNAL_REQUEST";
export const READ_JOURNALS_REQUEST = "READ_JOURNALS_REQUEST";
export const DELETE_JOURNALS_REQUEST = "DELETE_JOURNALS_REQUEST";
export const SAVE_BG_JOURNAL_REQUEST = "SAVE_BG_JOURNAL_REQUEST";
export const UPDATE_BG_JOURNAL_REQUEST = "UPDATE_BG_JOURNAL_REQUEST";
export const SAVE_JOURNAL_BANNER_REQUEST = "SAVE_JOURNAL_BANNER_REQUEST";
export const UPDATE_JOURNAL_BANNER_REQUEST = "UPDATE_JOURNAL_BANNER_REQUEST";
export const DELETE_JOURNAL_REQUEST = "DELETE_JOURNAL_REQUEST";

export const ADD_JOURNAL_NOTE_REQUEST = "ADD_JOURNAL_NOTE_REQUEST";
export const UPDATE_JOURNAL_NOTE_REQUEST = "UPDATE_JOURNAL_NOTE_REQUEST";
export const DELETE_JOURNAL_NOTE_REQUEST = "DELETE_JOURNAL_NOTE_REQUEST";

export const ADD_JOURNAL_NOTE_ITEM_REQUEST = "ADD_JOURNAL_NOTE_ITEM_REQUEST";
export const UPDATE_JOURNAL_NOTE_ITEM_REQUEST = "UPDATE_JOURNAL_NOTE_ITEM_REQUEST";
export const DELETE_JOURNAL_NOTE_ITEM_REQUEST = "DELETE_JOURNAL_NOTE_ITEM_REQUEST";

export const READ_CHAPTER_VIDEOS_REQUEST = "READ_CHAPTER_VIDEOS_REQUEST";
export const SAVE_CHAPTER_VIDEOS_REQUEST = "SAVE_CHAPTER_VIDEOS_REQUEST";
export const DELETE_CHAPTER_VIDEOS_REQUEST = "DELETE_CHAPTER_VIDEOS_REQUEST";
export const READ_CHAPTER_JOURNALS_REQUEST = "READ_CHAPTER_JOURNALS_REQUEST";
export const SAVE_CHAPTER_JOURNALS_REQUEST = "SAVE_CHAPTER_JOURNALS_REQUEST";
export const DELETE_CHAPTER_JOURNALS_REQUEST = "DELETE_CHAPTER_JOURNALS_REQUEST";
export const READ_VERSE_DETAILS_REQUEST = "READ_VERSE_DETAILS_REQUEST";

export const GET_JOURNAL_CATEGORIES_REQUEST = "GET_JOURNAL_CATEGORIES_REQUEST";
export const SAVE_JOURNAL_CATEGORIES_REQUEST = "SAVE_JOURNAL_CATEGORIES_REQUEST";
export const UPDATE_JOURNAL_CATEGORIES_REQUEST = "UPDATE_JOURNAL_CATEGORIES_REQUEST";
export const DELETE_JOURNAL_CATEGORIES_REQUEST = "DELETE_JOURNAL_CATEGORIES_REQUEST";
export const GET_PROMISE_REQUEST = "GET_PROMISE_REQUEST";
export const SAVE_SUPPORT_REQUEST = "SAVE_SUPPORT_REQUEST";
export const SAVE_PRAYER_REQUEST = "SAVE_PRAYER_REQUEST";
export const GLOBAL_BIBLE_SEARCH = "GLOBAL_BIBLE_SEARCH";
export const GLOBAL_VIDEO_SEARCH = "GLOBAL_VIDEO_SEARCH";
export const GLOBAL_TESTIMONY_SEARCH = "GLOBAL_TESTIMONY_SEARCH";
export const GLOBAL_PROMISE_SEARCH = "GLOBAL_PROMISE_SEARCH";
export const GLOBAL_JOURNAL_SEARCH = "GLOBAL_JOURNAL_SEARCH";
export const GLOBAL_CURRICULUM_SEARCH = "GLOBAL_CURRICULUM_SEARCH";
export const GLOBAL_CATEGORIES_SEARCH = "GLOBAL_CATEGORIES_SEARCH";
//Login and Sign Up
export const SIGN_UP_REQUEST = "SIGN_UP_REQUEST";
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const EMAIL_VERIFICATION_REQUEST = "EMAIL_VERIFICATION_REQUEST";
export const RESEND_VERIFICATION_REQUEST = "RESEND_VERIFICATION_REQUEST";
export const POST_GOOGLE_LOGIN_REQUEST = "POST_GOOGLE_LOGIN_REQUEST";
export const GET_PROMISE_OF_THE_DAY_REQUEST = "GET_PROMISE_OF_THE_DAY_REQUEST";

//Translate
export const TRANSLATE_TEXT_REQUEST = "TRANSLATE_TEXT_REQUEST";

//Upload Assests
export const UPLOAD_ASSEST_REQUEST = "UPLOAD_ASSEST_REQUEST";
export const UPLOAD_ASSEST_V2_REQUEST = "UPLOAD_ASSEST_V2_REQUEST";
export const UPLOAD_VIDEOS_REQUEST = "UPLOAD_VIDEOS_REQUEST";
export const UPLOAD_VIDEOS_V2_REQUEST = "UPLOAD_VIDEOS_V2_REQUEST";

//Languages
export const READ_LANGUAGE_LIST_REQUEST = "READ_LANGUAGE_LIST_REQUEST";
export const LANGUAGE_DASHBOARD_REQUEST = "LANGUAGE_DASHBOARD_REQUEST";
export const LAYOUT_DASHBOARD_REQUEST = "LAYOUT_DASHBOARD_REQUEST";
export const VIDEOS_DASHBOARD_REQUEST = "VIDEOS_DASHBOARD_REQUEST";
export const SAVE_LANGUAGES_REQUEST = "SAVE_LANGUAGES_REQUEST";
export const UPDATE_LANGUAGES_REQUEST = "UPDATE_LANGUAGES_REQUEST";
export const READ_LANGUAGES_REQUEST = "READ_LANGUAGES_REQUEST";
export const DELETE_LANGUAGE_REQUEST = "DELETE_LANGUAGE_REQUEST";
export const ACTIVE_OR_INACTIVE_LANGUAGES_REQUEST = "ACTIVE_OR_INACTIVE_LANGUAGES_REQUEST";

export const SAVE_LANGUAGE_LOGIN_META = "SAVE_LANGUAGE_LOGIN_META";
export const UPDATE_LANGUAGES_LOGIN_META = "UPDATE_LANGUAGES_LOGIN_META";
export const READ_LANGUAGES_LOGIN_META = "READ_LANGUAGES_LOGIN_META";
export const DELETE_LANGUAGES_LOGIN_META = "DELETE_LANGUAGES_LOGIN_META";

export const SAVE_LANGUAGES_SIGN_UP_REQUEST = "SAVE_LANGUAGES_SIGN_UP_REQUEST";
export const UPDATE_LANGUAGES_SIGN_UP_REQUEST = "UPDATE_LANGUAGES_SIGN_UP_REQUEST";
export const READ_LANGUAGES_SIGN_UP_REQUEST = "READ_LANGUAGES_SIGN_UP_REQUEST";
export const DELETE_LANGUAGES_SIGN_UP_REQUEST = "DELETE_LANGUAGES_SIGN_UP_REQUEST";

export const SAVE_LANGUAGES_FORGOT_PASSWORD_REQUEST = "SAVE_LANGUAGES_FORGOT_PASSWORD_REQUEST";
export const UPDATE_LANGUAGES_FORGOT_PASSWORD_REQUEST = "UPDATE_LANGUAGES_FORGOT_PASSWORD_REQUEST";
export const READ_LANGUAGES_FORGOT_PASSWORD_REQUEST = "READ_LANGUAGES_FORGOT_PASSWORD_REQUEST";
export const DELETE_LANGUAGES_FORGOT_PASSWORD_REQUEST = "DELETE_LANGUAGES_FORGOT_PASSWORD_REQUEST";

export const SAVE_LANGUAGES_HOME_DATA_REQUEST = "SAVE_LANGUAGES_HOME_DATA_REQUEST";
export const READ_LANGUAGES_HOME_DATA_REQUEST = "READ_LANGUAGES_HOME_DATA_REQUEST";
export const UPDATE_LANGUAGES_HOME_DATA_REQUEST = "UPDATE_LANGUAGES_HOME_DATA_REQUEST";
export const DELETE_LANGUAGES_HOME_DATA_REQUEST = "DELETE_LANGUAGES_HOME_DATA_REQUEST";

export const SAVE_LANGUAGES_PROMISES_DATA_REQUEST = "SAVE_LANGUAGES_PROMISES_DATA_REQUEST";
export const UPDATE_LANGUAGES_PROMISES_DATA_REQUEST = "UPDATE_LANGUAGES_PROMISES_DATA_REQUEST";

export const SAVE_LANGUAGE_CURRICULUM = "SAVE_LANGUAGE_CURRICULUM";
export const UPDATE_LANGUAGE_CURRICULUM = "UPDATE_LANGUAGE_CURRICULUM";
export const DELETE_LANGUAGE_CURRICULUM = "DELETE_LANGUAGE_CURRICULUM";
export const READ_LANGUAGE_CURRICULUM = "READ_LANGUAGE_CURRICULUM";

export const SAVE_LANGUAGE_FAVOURITES = "SAVE_LANGUAGE_FAVOURITES";
export const UPDATE_LANGUAGE_FAVOURITES = "UPDATE_LANGUAGE_FAVOURITES";
export const DELETE_LANGUAGE_FAVOURITES = "DELETE_LANGUAGE_FAVOURITES";
export const READ_LANGUAGE_FAVOURITES = "READ_LANGUAGE_FAVOURITES";

export const SAVE_LANGUAGE_TESTIMONIES_REQUEST = "SAVE_LANGUAGE_TESTIMONIES_REQUEST";
export const UPDATE_LANGUAGE_TESTIMONIES_REQUEST = "UPDATE_LANGUAGE_TESTIMONIES_REQUEST";
export const READ_LANGUAGE_TESTIMONIES_REQUEST = "READ_LANGUAGE_TESTIMONIES_REQUEST";
export const DELETE_LANGUAGE_TESTIMONIES_REQUEST = "DELETE_LANGUAGE_TESTIMONIES_REQUEST";

export const SAVE_LANGUAGES_GIVINGS_REQUEST = "SAVE_LANGUAGES_GIVINGS_REQUEST";
export const READ_LANGUAGES_GIVINGS_REQUEST = "READ_LANGUAGES_GIVINGS_REQUEST";
export const UPDATE_LANGUAGES_GIVINGS_REQUEST = "UPDATE_LANGUAGES_GIVINGS_REQUEST";
export const DELETE_LANGUAGES_GIVINGS_REQUEST = "DELETE_LANGUAGES_GIVINGS_REQUEST";

export const SAVE_LANGUAGES_MENU_REQUEST = "SAVE_LANGUAGES_MENU_REQUEST";
export const READ_LANGUAGES_MENU_REQUEST = "READ_LANGUAGES_MENU_REQUEST";
export const UPDATE_LANGUAGES_MENU_REQUEST = "UPDATE_LANGUAGES_MENU_REQUEST";
export const DELETE_LANGUAGES_MENU_REQUEST = "DELETE_LANGUAGES_MENU_REQUEST";

export const SAVE_LANGUAGES_MY_PROFILE_REQUEST = "SAVE_LANGUAGES_MY_PROFILE_REQUEST";
export const READ_LANGUAGES_MY_PROFILE_REQUEST = "READ_LANGUAGES_MY_PROFILE_REQUEST";
export const UPDATE_LANGUAGES_MY_PROFILE_REQUEST = "UPDATE_LANGUAGES_MY_PROFILE_REQUEST";
export const DELETE_LANGUAGES_MY_PROFILE_REQUEST = "DELETE_LANGUAGES_MY_PROFILE_REQUEST";

export const SAVE_LANGUAGES_MY_DOWNLOADS_REQUEST = "SAVE_LANGUAGES_MY_DOWNLOADS_REQUEST";
export const READ_LANGUAGES_MY_DOWNLOADS_REQUEST = "READ_LANGUAGES_MY_DOWNLOADS_REQUEST";
export const UPDATE_LANGUAGES_MY_DOWNLOADS_REQUEST = "UPDATE_LANGUAGES_MY_DOWNLOADS_REQUEST";
export const DELETE_LANGUAGES_MY_DOWNLOADS_REQUEST = "DELETE_LANGUAGES_MY_DOWNLOADS_REQUEST";

export const SAVE_LANGUAGES_MY_GIVINGS_REQUEST = "SAVE_LANGUAGES_MY_GIVINGS_REQUEST";
export const READ_LANGUAGES_MY_GIVINGS_REQUEST = "READ_LANGUAGES_MY_GIVINGS_REQUEST";
export const UPDATE_LANGUAGES_MY_GIVINGS_REQUEST = "UPDATE_LANGUAGES_MY_GIVINGS_REQUEST";
export const DELETE_LANGUAGES_MY_GIVINGS_REQUEST = "DELETE_LANGUAGES_MY_GIVINGS_REQUEST";

export const SAVE_LANGUAGES_HELP_AND_SUPPORT_REQUEST = "SAVE_LANGUAGES_HELP_AND_SUPPORT_REQUEST";
export const READ_LANGUAGES_HELP_AND_SUPPORT_REQUEST = "READ_LANGUAGES_HELP_AND_SUPPORT_REQUEST";
export const UPDATE_LANGUAGES_HELP_AND_SUPPORT_REQUEST =
  "UPDATE_LANGUAGES_HELP_AND_SUPPORT_REQUEST";
export const DELETE_LANGUAGES_HELP_AND_SUPPORT_REQUEST =
  "DELETE_LANGUAGES_HELP_AND_SUPPORT_REQUEST";

export const SAVE_LANGUAGES_HELP_AND_SUPPORT_ACCORDIAN_REQUEST =
  "SAVE_LANGUAGES_HELP_AND_SUPPORT_ACCORDIAN_REQUEST";
export const READ_LANGUAGES_HELP_AND_SUPPORT_ACCORDIAN_REQUEST =
  "READ_LANGUAGES_HELP_AND_SUPPORT_ACCORDIAN_REQUEST";
export const UPDATE_LANGUAGES_HELP_AND_SUPPORT_ACCORDIAN_REQUEST =
  "UPDATE_LANGUAGES_HELP_AND_SUPPORT_ACCORDIAN_REQUEST";
export const DELETE_LANGUAGES_HELP_AND_SUPPORT_ACCORDIAN_REQUEST =
  "DELETE_LANGUAGES_HELP_AND_SUPPORT_ACCORDIAN_REQUEST";

export const SAVE_LANGUAGES_ABOUT_TWG_REQUEST = "SAVE_LANGUAGES_ABOUT_TWG_REQUEST";
export const READ_LANGUAGES_ABOUT_TWG_REQUEST = "READ_LANGUAGES_ABOUT_TWG_REQUEST";
export const UPDATE_LANGUAGES_ABOUT_TWG_REQUEST = "UPDATE_LANGUAGES_ABOUT_TWG_REQUEST";
export const DELETE_LANGUAGES_ABOUT_TWG_REQUEST = "DELETE_LANGUAGES_ABOUT_TWG_REQUEST";

export const SAVE_CURRICULUM_REQUEST = "SAVE_CURRICULUM_REQUEST";
export const UPDATE_CURRICULUM_REQUEST = "UPDATE_CURRICULUM_REQUEST";
export const READ_CURRICULUM_REQUEST = "READ_CURRICULUM_REQUEST";
export const DELETE_CURRICULUM_REQUEST = "DELETE_CURRICULUM_REQUEST";

export const SAVE_CURRICULUM_PREVIEW_REQUEST = "SAVE_CURRICULUM_PREVIEW_REQUEST";
export const UPDATE_CURRICULUM_PREVIEW_REQUEST = "UPDATE_CURRICULUM_PREVIEW_REQUEST";

export const SAVE_CURRICULUM_LANGUAGE_PREVIEW_REQUEST = "SAVE_CURRICULUM_LANGUAGE_PREVIEW_REQUEST";
export const UPDATE_CURRICULUM_LANGUAGE_PREVIEW_REQUEST =
  "UPDATE_CURRICULUM_LANGUAGE_PREVIEW_REQUEST";

export const SAVE_COMMON_BG_CURRICULUM_REQUEST = "SAVE_COMMON_BG_CURRICULUM_REQUEST";
export const UPDATE_COMMON_BG_CURRICULUM_REQUEST = "UPDATE_COMMON_BG_CURRICULUM_REQUEST";

export const SAVE_BG_CURRICULUM_REQUEST = "SAVE_BG_CURRICULUM_REQUEST";
export const UPDATE_BG_CURRICULUM_REQUEST = "UPDATE_BG_CURRICULUM_REQUEST";
export const READ_BG_CURRICULUM_REQUEST = "READ_BG_CURRICULUM_REQUEST";
export const DELETE_BG_CURRICULUM_REQUEST = "DELETE_BG_CURRICULUM_REQUEST";

export const SAVE_CURRICULUM_LANGUAGE_REQUEST = "SAVE_CURRICULUM_LANGUAGE_REQUEST";
export const UPDATE_CURRICULUM_LANGUAGE_REQUEST = "UPDATE_CURRICULUM_LANGUAGE_REQUEST";
export const READ_CURRICULUM_LANGUAGE_REQUEST = "READ_CURRICULUM_LANGUAGE_REQUEST";
export const DELETE_CURRICULUM_LANGUAGE_REQUEST = "DELETE_CURRICULUM_LANGUAGE_REQUEST";

export const SAVE_BG_CURRICULUM_LANGUAGE_REQUEST = "SAVE_BG_CURRICULUM_LANGUAGE_REQUEST";
export const UPDATE_BG_CURRICULUM_LANGUAGE_REQUEST = "UPDATE_BG_CURRICULUM_LANGUAGE_REQUEST";
export const READ_BG_CURRICULUM_LANGUAGE_REQUEST = "READ_BG_CURRICULUM_LANGUAGE_REQUEST";
export const DELETE_BG_CURRICULUM_LANGUAGE_REQUEST = "DELETE_BG_CURRICULUM_LANGUAGE_REQUEST";
export const SAVE_PICK_WHERE_LEFT_REQUEST = "SAVE_PICK_WHERE_LEFT_REQUEST";
export const READ_LANGUAGE_REQUEST = "READ_LANGUAGE_REQUEST";
export const LAYOUT_MAIN_CAROUSEL_REQUEST = "LAYOUT_MAIN_CAROUSEL_REQUEST";
export const LAYOUT_TOP10_REQUEST = "LAYOUT_TOP10_REQUEST";
export const LAYOUT_HOME_SCREEN_REQUEST = "LAYOUT_HOME_SCREEN_REQUEST";

//User
export const GET_PROFILE_REQUEST = "GET_PROFILE_REQUEST";
export const SAVE_USER_PROFILE_REQUEST = "SAVE_USER_PROFILE_REQUEST";
export const UPDATE_USER_PROFILE_REQUEST = "UPDATE_USER_PROFILE_REQUEST";
export const SAVE_CURRICULUM_LESSON_REQUEST = "SAVE_CURRICULUM_LESSON_REQUEST";
export const UPDATE_CURRICULUM_LESSON_REQUEST = "UPDATE_CURRICULUM_LESSON_REQUEST";
export const READ_CURRICULUM_LESSON_REQUEST = "READ_CURRICULUM_LESSON_REQUEST";
export const DELETE_CURRICULUM_LESSON_REQUEST = "DELETE_CURRICULUM_LESSON_REQUEST";
export const GET_PICK_WHERE_LEFT_REQUEST = "GET_PICK_WHERE_LEFT_REQUEST";
export const GET_ACHIEVEMENTS = "GET_ACHIEVEMENTS";
export const READ_FAV_REQUEST = "READ_FAV_REQUEST";
export const UPDATE_USER_PROFILE_INFO = "UPDATE_USER_PROFILE_INFO";
export const SET_ACCESS_TOKEN = "SET_ACCESS_TOKEN";

export const SAVE_CURRICULUM_LANGUAGE_LESSON_PREVIEW_REQUEST =
  "SAVE_CURRICULUM_LANGUAGE_LESSON_PREVIEW_REQUEST";
export const UPDATE_CURRICULUM_LANGUAGE_LESSON_PREVIEW_REQUEST =
  "UPDATE_CURRICULUM_LANGUAGE_LESSON_PREVIEW_REQUEST";
export const SAVE_CURRICULUM_LANGUAGE_LESSON_REQUEST = "SAVE_CURRICULUM_LANGUAGE_LESSON_REQUEST";
export const UPDATE_CURRICULUM_LANGUAGE_LESSON_REQUEST =
  "UPDATE_CURRICULUM_LANGUAGE_LESSON_REQUEST";
export const READ_CURRICULUM_LANGUAGE_LESSON_REQUEST = "READ_CURRICULUM_LANGUAGE_LESSON_REQUEST";
export const DELETE_CURRICULUM_LANGUAGE_LESSON_REQUEST =
  "DELETE_CURRICULUM_LANGUAGE_LESSON_REQUEST";

export const SAVE_CURRICULUM_LESSON_COMMON_THUMBNAIL_REQUEST =
  "SAVE_CURRICULUM_LESSON_COMMON_THUMBNAIL_REQUEST";
export const UPDATE_CURRICULUM_LESSON_COMMON_THUMBNAIL_REQUEST =
  "UPDATE_CURRICULUM_LESSON_COMMON_THUMBNAIL_REQUEST";

export const SAVE_CURRICULUM_LESSON_PREVIEW_REQUEST = "SAVE_CURRICULUM_LESSON_PREVIEW_REQUEST";
export const UPDATE_CURRICULUM_LESSON_PREVIEW_REQUEST = "UPDATE_CURRICULUM_LESSON_PREVIEW_REQUEST";

export const SAVE_CURRICULUM_LESSON_THUMBNAIL_REQUEST = "SAVE_CURRICULUM_LESSON_THUMBNAIL_REQUEST";
export const UPDATE_CURRICULUM_LESSON_THUMBNAIL_REQUEST =
  "UPDATE_CURRICULUM_LESSON_THUMBNAIL_REQUEST";
export const READ_CURRICULUM_LESSON_THUMBNAIL_REQUEST = "READ_CURRICULUM_LESSON_THUMBNAIL_REQUEST";
export const DELETE_CURRICULUM_LESSON_THUMBNAIL_REQUEST =
  "DELETE_CURRICULUM_LESSON_THUMBNAIL_REQUEST";

export const SAVE_CURRICULUM_LANGUAGE_LESSON_THUMBNAIL_REQUEST =
  "SAVE_CURRICULUM_LANGUAGE_LESSON_THUMBNAIL_REQUEST";
export const UPDATE_CURRICULUM_LANGUAGE_LESSON_THUMBNAIL_REQUEST =
  "UPDATE_CURRICULUM_LANGUAGE_LESSON_THUMBNAIL_REQUEST";
export const READ_CURRICULUM_LANGUAGE_LESSON_THUMBNAIL_REQUEST =
  "READ_CURRICULUM_LANGUAGE_LESSON_THUMBNAIL_REQUEST";
export const DELETE_CURRICULUM_LANGUAGE_LESSON_THUMBNAIL_REQUEST =
  "DELETE_CURRICULUM_LANGUAGE_LESSON_THUMBNAIL_REQUEST";

export const SAVE_CURRICULUM_LESSON_SLIDE_LANGUAGE_REQUEST =
  "SAVE_CURRICULUM_LESSON_SLIDE_LANGUAGE_REQUEST";
export const UPDATE_CURRICULUM_LESSON_SLIDE_LANGUAGE_REQUEST =
  "UPDATE_CURRICULUM_LESSON_SLIDE_LANGUAGE_REQUEST";

export const SAVE_CURRICULUM_LESSON_SLIDE_REQUEST = "SAVE_CURRICULUM_LESSON_SLIDE_REQUEST";
export const UPDATE_CURRICULUM_LESSON_SLIDE_REQUEST = "UPDATE_CURRICULUM_LESSON_SLIDE_REQUEST";
export const READ_CURRICULUM_LESSON_SLIDE_REQUEST = "READ_CURRICULUM_LESSON_SLIDE_REQUEST";
export const DELETE_CURRICULUM_LESSON_SLIDE_REQUEST = "DELETE_CURRICULUM_LESSON_SLIDE_REQUEST";

export const SAVE_CURRICULUM_LANGUAGE_LESSON_SLIDE_REQUEST =
  "SAVE_CURRICULUM_LANGUAGE_LESSON_SLIDE_REQUEST";
export const UPDATE_CURRICULUM_LANGUAGE_LESSON_SLIDE_REQUEST =
  "UPDATE_CURRICULUM_LANGUAGE_LESSON_SLIDE_REQUEST";
export const READ_CURRICULUM_LANGUAGE_LESSON_SLIDE_REQUEST =
  "READ_CURRICULUM_LANGUAGE_LESSON_SLIDE_REQUEST";
export const DELETE_CURRICULUM_LANGUAGE_LESSON_SLIDE_REQUEST =
  "DELETE_CURRICULUM_LANGUAGE_THUMBNAIL_LESSON_REQUEST";

export const SAVE_CURRICULUM_LESSON_BG_SLIDE_REQUEST = "SAVE_CURRICULUM_LESSON_BG_SLIDE_REQUEST";
export const UPDATE_CURRICULUM_LESSON_BG_SLIDE_REQUEST =
  "UPDATE_CURRICULUM_LESSON_BG_SLIDE_REQUEST";
export const READ_CURRICULUM_LESSON_BG_SLIDE_REQUEST = "READ_CURRICULUM_LESSON_BG_SLIDE_REQUEST";
export const DELETE_CURRICULUM_LESSON_BG_SLIDE_REQUEST =
  "DELETE_CURRICULUM_THUMBNABG_IL_LESSON_REQUEST";

export const SAVE_CURRICULUM_LANGUAGE_LESSON_BG_SLIDE_REQUEST =
  "SAVE_CURRICULUM_LANGUAGE_LESSON_BG_SLIDE_REQUEST";
export const UPDATE_CURRICULUM_LANGUAGE_LESSON_BG_SLIDE_REQUEST =
  "UPDATE_CURRICULUM_LANGUAGE_LESSON_BG_SLIDE_REQUEST";
export const READ_CURRICULUM_LANGUAGE_LESSON_BG_SLIDE_REQUEST =
  "READ_CURRICULUM_LANGUAGE_LESSON_BG_SLIDE_REQUEST";
export const DELETE_CURRICULUM_LANGUAGE_LESSON_BG_SLIDE_REQUEST =
  "DELETE_CURRICULUM_LANGUAGE_THUMBNABG_IL_LESSON_REQUEST";

export const SAVE_CURRICULUM_LESSON_SLIDE_TYPE_REQUEST =
  "SAVE_CURRICULUM_LESSON_SLIDE_TYPE_REQUEST";
export const UPDATE_CURRICULUM_LESSON_SLIDE_TYPE_REQUEST =
  "UPDATE_CURRICULUM_LESSON_SLIDE_TYPE_REQUEST";
export const READ_CURRICULUM_LESSON_SLIDE_TYPE_REQUEST =
  "READ_CURRICULUM_LESSON_SLIDE_TYPE_REQUEST";
export const DELETE_CURRICULUM_LESSON_SLIDE_TYPE_REQUEST =
  "DELETE_CURRICULUM_LESSON_SLIDE_TYPE_REQUEST";

export const SAVE_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_REQUEST =
  "SAVE_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_REQUEST";
export const UPDATE_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_REQUEST =
  "UPDATE_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_REQUEST";
export const READ_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_REQUEST =
  "READ_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_REQUEST";
export const DELETE_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_REQUEST =
  "DELETE_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_REQUEST";

export const SAVE_CURRICULUM_LESSON_SLIDE_TYPE_BG_REQUEST =
  "SAVE_CURRICULUM_LESSON_SLIDE_TYPE_BG_REQUEST";
export const UPDATE_CURRICULUM_LESSON_SLIDE_TYPE_BG_REQUEST =
  "UPDATE_CURRICULUM_LESSON_SLIDE_TYPE_BG_REQUEST";
export const READ_CURRICULUM_LESSON_SLIDE_TYPE_BG_REQUEST =
  "READ_CURRICULUM_LESSON_SLIDE_TYPE_BG_REQUEST";
export const DELETE_CURRICULUM_LESSON_SLIDE_TYPE_BG_REQUEST =
  "DELETE_CURRICULUM_LESSON_SLIDE_TYPE_BG_REQUEST";

export const SAVE_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_BG_REQUEST =
  "SAVE_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_BG_REQUEST";
export const UPDATE_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_BG_REQUEST =
  "UPDATE_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_BG_REQUEST";
export const READ_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_BG_REQUEST =
  "READ_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_BG_REQUEST";
export const DELETE_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_BG_REQUEST =
  "DELETE_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_BG_REQUEST";

export const SAVE_CURRICULUM_LESSON_SLIDE_TYPE_ASSET_REQUEST =
  "SAVE_CURRICULUM_LESSON_SLIDE_TYPE_ASSET_REQUEST";
export const UPDATE_CURRICULUM_LESSON_SLIDE_TYPE_ASSET_REQUEST =
  "UPDATE_CURRICULUM_LESSON_SLIDE_TYPE_ASSET_REQUEST";
export const READ_CURRICULUM_LESSON_SLIDE_TYPE_ASSET_REQUEST =
  "READ_CURRICULUM_LESSON_SLIDE_TYPE_ASSET_REQUEST";
export const DELETE_CURRICULUM_LESSON_SLIDE_TYPE_ASSET_REQUEST =
  "DELETE_CURRICULUM_LESSON_SLIDE_TYPE_ASSET_REQUEST";

export const SAVE_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_ASSET_REQUEST =
  "SAVE_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_ASSET_REQUEST";
export const UPDATE_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_ASSET_REQUEST =
  "UPDATE_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_ASSET_REQUEST";
export const READ_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_ASSET_REQUEST =
  "READ_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_ASSET_REQUEST";
export const DELETE_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_ASSET_REQUEST =
  "DELETE_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_ASSET_REQUEST";

export const SAVE_CURRICULUM_LESSON_SLIDE_TYPE_LINK_REQUEST =
  "SAVE_CURRICULUM_LESSON_SLIDE_TYPE_LINK_REQUEST";
export const UPDATE_CURRICULUM_LESSON_SLIDE_TYPE_LINK_REQUEST =
  "UPDATE_CURRICULUM_LESSON_SLIDE_TYPE_LINK_REQUEST";
export const READ_CURRICULUM_LESSON_SLIDE_TYPE_LINK_REQUEST =
  "READ_CURRICULUM_LESSON_SLIDE_TYPE_LINK_REQUEST";
export const DELETE_CURRICULUM_LESSON_SLIDE_TYPE_LINK_REQUEST =
  "DELETE_CURRICULUM_LESSON_SLIDE_TYPE_LINK_REQUEST";

export const SAVE_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_LINK_REQUEST =
  "SAVE_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_LINK_REQUEST";
export const UPDATE_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_LINK_REQUEST =
  "UPDATE_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_LINK_REQUEST";
export const READ_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_LINK_REQUEST =
  "READ_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_LINK_REQUEST";
export const DELETE_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_LINK_REQUEST =
  "DELETE_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_LINK_REQUEST";

export const SAVE_CURRICULUM_LESSON_SLIDE_TYPE_POLL_REQUEST =
  "SAVE_CURRICULUM_LESSON_SLIDE_TYPE_POLL_REQUEST";
export const UPDATE_CURRICULUM_LESSON_SLIDE_TYPE_POLL_REQUEST =
  "UPDATE_CURRICULUM_LESSON_SLIDE_TYPE_POLL_REQUEST";
export const READ_CURRICULUM_LESSON_SLIDE_TYPE_POLL_REQUEST =
  "READ_CURRICULUM_LESSON_SLIDE_TYPE_POLL_REQUEST";
export const DELETE_CURRICULUM_LESSON_SLIDE_TYPE_POLL_REQUEST =
  "DELETE_CURRICULUM_LESSON_SLIDE_TYPE_POLL_REQUEST";

export const SAVE_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_POLL_REQUEST =
  "SAVE_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_POLL_REQUEST";
export const UPDATE_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_POLL_REQUEST =
  "UPDATE_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_POLL_REQUEST";
export const READ_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_POLL_REQUEST =
  "READ_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_POLL_REQUEST";
export const DELETE_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_POLL_REQUEST =
  "DELETE_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_POLL_REQUEST";

export const SAVE_CURRICULUM_LESSON_SLIDE_TYPE_POLL_OPTIONS_REQUEST =
  "SAVE_CURRICULUM_LESSON_SLIDE_TYPE_POLL_OPTIONS_REQUEST";
export const UPDATE_CURRICULUM_LESSON_SLIDE_TYPE_POLL_OPTIONS_REQUEST =
  "UPDATE_CURRICULUM_LESSON_SLIDE_TYPE_POLL_OPTIONS_REQUEST";
export const READ_CURRICULUM_LESSON_SLIDE_TYPE_POLL_OPTIONS_REQUEST =
  "READ_CURRICULUM_LESSON_SLIDE_TYPE_POLL_OPTIONS_REQUEST";
export const DELETE_CURRICULUM_LESSON_SLIDE_TYPE_POLL_OPTIONS_REQUEST =
  "DELETE_CURRICULUM_LESSON_SLIDE_TYPE_POLL_OPTIONS_REQUEST";
export const SAVE_CURRICULUM_LESSON_SLIDE_TYPE_POLL_OPTIONS_VOTE_REQUEST =
  "SAVE_CURRICULUM_LESSON_SLIDE_TYPE_POLL_OPTIONS_VOTE_REQUEST";
export const UPDATE_CURRICULUM_LESSON_SLIDE_TYPE_POLL_OPTIONS_VOTE_REQUEST =
  "UPDATE_CURRICULUM_LESSON_SLIDE_TYPE_POLL_OPTIONS_VOTE_REQUEST";
export const READ_CURRICULUM_LESSON_SLIDE_TYPE_POLL_OPTIONS_VOTE_REQUEST =
  "READ_CURRICULUM_LESSON_SLIDE_TYPE_POLL_OPTIONS_VOTE_REQUEST";
export const DELETE_CURRICULUM_LESSON_SLIDE_TYPE_POLL_OPTIONS_VOTE_REQUEST =
  "DELETE_CURRICULUM_LESSON_SLIDE_TYPE_POLL_OPTIONS_VOTE_REQUEST";

export const SAVE_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_POLL_OPTIONS_REQUEST =
  "SAVE_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_POLL_OPTIONS_REQUEST";
export const UPDATE_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_POLL_OPTIONS_REQUEST =
  "UPDATE_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_POLL_OPTIONS_REQUEST";
export const READ_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_POLL_OPTIONS_REQUEST =
  "READ_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_POLL_OPTIONS_REQUEST";
export const DELETE_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_POLL_OPTIONS_REQUEST =
  "DELETE_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_POLL_OPTIONS_REQUEST";
export const SAVE_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_POLL_OPTIONS_VOTE_REQUEST =
  "SAVE_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_POLL_OPTIONS_VOTE_REQUEST";
export const UPDATE_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_POLL_OPTIONS_VOTE_REQUEST =
  "UPDATE_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_POLL_OPTIONS_VOTE_REQUEST";
export const READ_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_POLL_OPTIONS_VOTE_REQUEST =
  "READ_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_POLL_OPTIONS_VOTE_REQUEST";
export const DELETE_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_POLL_OPTIONS_VOTE_REQUEST =
  "DELETE_CURRICULUM_LANGUAGE_LESSON_SLIDE_TYPE_POLL_OPTIONS_VOTE_REQUEST";

export const SAVE_VIDEOS_REQUEST = "SAVE_VIDEOS_REQUEST";
export const UPDATE_VIDEOS_REQUEST = "UPDATE_VIDEOS_REQUEST";
export const READ_VIDEOS_REQUEST = "READ_VIDEOS_REQUEST";
export const DELETE_VIDEOS_REQUEST = "DELETE_VIDEOS_REQUEST";

export const SAVE_VIDEOS_LANGUAGE_REQUEST = "SAVE_VIDEOS_LANGUAGE_REQUEST";
export const UPDATE_VIDEOS_LANGUAGE_REQUEST = "UPDATE_VIDEOS_LANGUAGE_REQUEST";
export const READ_VIDEOS_LANGUAGE_REQUEST = "READ_VIDEOS_LANGUAGE_REQUEST";
export const DELETE_VIDEOS_LANGUAGE_REQUEST = "DELETE_VIDEOS_LANGUAGE_REQUEST";

export const UPDATE_COMMON_URLS_REQUEST = "UPDATE_COMMON_URLS_REQUEST";
export const SAVE_VIDEOS_URLS_REQUEST = "SAVE_VIDEOS_URLS_REQUEST";
export const SAVE_COMMON_URLS_REQUEST = "SAVE_COMMON_URLS_REQUEST";
export const UPDATE_VIDEOS_URLS_REQUEST = "UPDATE_VIDEOS_URLS_REQUEST";
export const SAVE_VIDEO_PREVIEW_URLS_REQUEST = "SAVE_VIDEO_PREVIEW_URLS_REQUEST";
export const UPDATE_VIDEO_PREVIEW_URLS_REQUEST = "UPDATE_VIDEO_PREVIEW_URLS_REQUEST";
export const READ_VIDEOS_URLS_REQUEST = "READ_VIDEOS_URLS_REQUEST";
export const DELETE_VIDEOS_URLS_REQUEST = "DELETE_VIDEOS_URLS_REQUEST";
export const SAVE_VIDEO_LANGUAGE_REQUEST = "SAVE_VIDEO_LANGUAGE_REQUEST";
export const SAVE_LAYOUT_LANGUAGE_REQUEST = "SAVE_LAYOUT_LANGUAGE_REQUEST";
export const UPDATE_LAYOUT_LANGUAGE_REQUEST = "UPDATE_LAYOUT_LANGUAGE_REQUEST";
export const SAVE_CATEGORIES_LANGUAGE_REQUEST = "SAVE_CATEGORIES_LANGUAGE_REQUEST";
export const UPDATE_CATEGORIES_LANGUAGE_REQUEST = "UPDATE_CATEGORIES_LANGUAGE_REQUEST";
export const SAVE_CATEGORIES_PREVIEW_LANGUAGE_REQUEST = "SAVE_CATEGORIES_PREVIEW_LANGUAGE_REQUEST";
export const UPDATE_CATEGORIES_PREVIEW_LANGUAGE_REQUEST =
  "UPDATE_CATEGORIES_PREVIEW_LANGUAGE_REQUEST";
export const UPDATE_VIDEO_LANGUAGE_REQUEST = "UPDATE_VIDEO_LANGUAGE_REQUEST";
export const SAVE_VIDEO_URL_LANGUAGE_REQUEST = "SAVE_VIDEO_URL_LANGUAGE_REQUEST";
export const UPDATE_VIDEO_URL_LANGUAGE_REQUEST = "UPDATE_VIDEO_URL_LANGUAGE_REQUEST";
export const SAVE_VIDEO_PREVIEW_LANGUAGE_REQUEST = "SAVE_VIDEO_PREVIEW_LANGUAGE_REQUEST";
export const UPDATE_VIDEO_PREVIEW_LANGUAGE_REQUEST = "UPDATE_VIDEO_PREVIEW_LANGUAGE_REQUEST";
export const SAVE_VIDEO_DOWNLOAD_URL_LANGUAGE_REQUEST = "SAVE_VIDEO_DOWNLOAD_URL_LANGUAGE_REQUEST";
export const UPDATE_VIDEO_DOWNLOAD_URL_LANGUAGE_REQUEST =
  "UPDATE_VIDEO_DOWNLOAD_URL_LANGUAGE_REQUEST";

export const SAVE_VIDEOS_URLS_LANGUAGE_REQUEST = "SAVE_VIDEOS_URLS_LANGUAGE_REQUEST";
export const UPDATE_VIDEOS_URLS_LANGUAGE_REQUEST = "UPDATE_VIDEOS_URLS_LANGUAGE_REQUEST";
export const READ_VIDEOS_URLS_LANGUAGE_REQUEST = "READ_VIDEOS_URLS_LANGUAGE_REQUEST";
export const DELETE_VIDEOS_URLS_LANGUAGE_REQUEST = "DELETE_VIDEOS_URLS_LANGUAGE_REQUEST";

export const SAVE_VIDEOS_DOWNLOAD_URLS_REQUEST = "SAVE_VIDEOS_DOWNLOAD_URLS_REQUEST";
export const UPDATE_VIDEOS_DOWNLOAD_URLS_REQUEST = "UPDATE_VIDEOS_DOWNLOAD_URLS_REQUEST";
export const READ_VIDEOS_DOWNLOAD_URLS_REQUEST = "READ_VIDEOS_DOWNLOAD_URLS_REQUEST";
export const DELETE_VIDEOS_DOWNLOAD_URLS_REQUEST = "DELETE_VIDEOS_DOWNLOAD_URLS_REQUEST";

export const SAVE_LANGUAGE_VIDEOS_DOWNLOAD_URLS_REQUEST =
  "SAVE_LANGUAGE_VIDEOS_DOWNLOAD_URLS_REQUEST";
export const UPDATE_LANGUAGE_VIDEOS_DOWNLOAD_URLS_REQUEST =
  "UPDATE_LANGUAGE_VIDEOS_DOWNLOAD_URLS_REQUEST";
export const READ_LANGUAGE_VIDEOS_DOWNLOAD_URLS_REQUEST =
  "READ_LANGUAGE_VIDEOS_DOWNLOAD_URLS_REQUEST";
export const DELETE_LANGUAGE_VIDEOS_DOWNLOAD_URLS_REQUEST =
  "DELETE_LANGUAGE_VIDEOS_DOWNLOAD_URLS_REQUEST";

export const SAVE_VIDEOS_THUMBNAIL_URLS_REQUEST = "SAVE_VIDEOS_THUMBNAIL_URLS_REQUEST";
export const UPDATE_VIDEOS_THUMBNAIL_URLS_REQUEST = "UPDATE_VIDEOS_THUMBNAIL_URLS_REQUEST";
export const READ_VIDEOS_THUMBNAIL_URLS_REQUEST = "READ_VIDEOS_THUMBNAIL_URLS_REQUEST";
export const DELETE_VIDEOS_THUMBNAIL_URLS_REQUEST = "DELETE_VIDEOS_THUMBNAIL_URLS_REQUEST";

export const SAVE_LANGUAGE_VIDEOS_THUMBNAIL_URLS_REQUEST =
  "SAVE_LANGUAGE_VIDEOS_THUMBNAIL_URLS_REQUEST";
export const UPDATE_LANGUAGE_VIDEOS_THUMBNAIL_URLS_REQUEST =
  "UPDATE_LANGUAGE_VIDEOS_THUMBNAIL_URLS_REQUEST";
export const READ_LANGUAGE_VIDEOS_THUMBNAIL_URLS_REQUEST =
  "READ_LANGUAGE_VIDEOS_THUMBNAIL_URLS_REQUEST";
export const DELETE_LANGUAGE_VIDEOS_THUMBNAIL_URLS_REQUEST =
  "DELETE_LANGUAGE_VIDEOS_THUMBNAIL_URLS_REQUEST";

export const SAVE_VIDEOS_RELATED_REQUEST = "SAVE_VIDEOS_RELATED_REQUEST";
export const READ_VIDEOS_RELATED_REQUEST = "READ_VIDEOS_RELATED_REQUEST";
export const DELETE_VIDEOS_RELATED_REQUEST = "DELETE_VIDEOS_RELATED_REQUEST";

export const SAVE_CATEGORIES_REQUEST = "SAVE_CATEGORIES_REQUEST";
export const SAVE_COMMON_THUMBNAIL_CATEGORIES_REQUEST = "SAVE_COMMON_THUMBNAIL_CATEGORIES_REQUEST";
export const UPDATE_COMMON_THUMBNAIL_CATEGORIES_REQUEST =
  "UPDATE_COMMON_THUMBNAIL_CATEGORIES_REQUEST";
export const UPDATE_CATEGORY_PREVIEW_REQUEST = "UPDATE_CATEGORY_PREVIEW_REQUEST";
export const SAVE_CATEGORY_PREVIEW_REQUEST = "SAVE_CATEGORY_PREVIEW_REQUEST";
export const UPDATE_CATEGORIES_REQUEST = "UPDATE_CATEGORIES_REQUEST";
export const READ_CATEGORIES_REQUEST = "READ_CATEGORIES_REQUEST";
export const DELETE_CATEGORIES_REQUEST = "DELETE_CATEGORIES_REQUEST";
export const SAVE_CATEGORIES_ICON_REQUEST = "SAVE_CATEGORIES_ICON_REQUEST";
export const UPDATE_CATEGORIES_ICON_REQUEST = "UPDATE_CATEGORIES_ICON_REQUEST";
export const READ_CATEGORIES_ICON_REQUEST = "READ_CATEGORIES_ICON_REQUEST";
export const DELETE_CATEGORIES_ICON_REQUEST = "DELETE_CATEGORIES_ICON_REQUEST";
export const SAVE_CATEGORIES_RELATED_REQUEST = "SAVE_CATEGORIES_RELATED_REQUEST";
export const UPDATE_CATEGORIES_RELATED_REQUEST = "UPDATE_CATEGORIES_RELATED_REQUEST";
export const READ_CATEGORIES_RELATED_REQUEST = "READ_CATEGORIES_RELATED_REQUEST";
export const DELETE_CATEGORIES_RELATED_REQUEST = "DELETE_CATEGORIES_RELATED_REQUEST";

export const SAVE_LANGUAGE_CATEGORIES_REQUEST = "SAVE_LANGUAGE_CATEGORIES_REQUEST";
export const UPDATE_LANGUAGE_CATEGORIES_REQUEST = "UPDATE_LANGUAGE_CATEGORIES_REQUEST";
export const READ_LANGUAGE_CATEGORIES_REQUEST = "READ_LANGUAGE_CATEGORIES_REQUEST";
export const DELETE_LANGUAGE_CATEGORIES_REQUEST = "DELETE_LANGUAGE_CATEGORIES_REQUEST";

export const SAVE_LAYOUT_REQUEST = "SAVE_LAYOUT_REQUEST";
export const UPDATE_LAYOUT_REQUEST = "UPDATE_LAYOUT_REQUEST";
export const READ_LAYOUT_REQUEST = "READ_LAYOUT_REQUEST";
export const DELETE_LAYOUT_REQUEST = "DELETE_LAYOUT_REQUEST";

export const SAVE_CATEGORY_LAYOUT_REQUEST = "SAVE_CATEGORY_LAYOUT_REQUEST";
export const UPDATE_CATEGORY_LAYOUT_REQUEST = "UPDATE_CATEGORY_LAYOUT_REQUEST";
export const DELETE_CATEGORY_LAYOUT_REQUEST = "DELETE_CATEGORY_LAYOUT_REQUEST";
export const READ_CATEGORY_LAYOUT_REQUEST = "READ_CATEGORY_LAYOUT_REQUEST";

export const SAVE_CURRICULUM_LAYOUT_REQUEST = "SAVE_CURRICULUM_LAYOUT_REQUEST";
export const READ_CURRICULUM_LAYOUT_REQUEST = "READ_CURRICULUM_LAYOUT_REQUEST";
export const DELETE_CURRICULUM_LAYOUT_REQUEST = "DELETE_CURRICULUM_LAYOUT_REQUEST";
export const UPDATE_CURRICULUM_LAYOUT_REQUEST = "UPDATE_CURRICULUM_LAYOUT_REQUEST";

export const SAVE_VIDEO_LAYOUT_REQUEST = "SAVE_VIDEO_LAYOUT_REQUEST";
export const UPDATE_VIDEO_LAYOUT_REQUEST = "UPDATE_VIDEO_LAYOUT_REQUEST";
export const READ_VIDEO_LAYOUT_REQUEST = "READ_VIDEO_LAYOUT_REQUEST";
export const DELETE_VIDEO_LAYOUT_REQUEST = "DELETE_VIDEO_LAYOUT_REQUEST";
export const SEARCH_VIDEO_URL_REQUEST = "SEARCH_VIDEO_URL_REQUEST";

export const READ_TESTIMONY_CATEGORY_REQUEST = "READ_TESTIMONY_CATEGORY_REQUEST";
export const DELETE_TESTIMONY_CATEGORY_REQUEST = "DELETE_TESTIMONY_CATEGORY_REQUEST";
export const SAVE_TESTIMONY_CATEGORY_REQUEST = "SAVE_TESTIMONY_CATEGORY_REQUEST";
export const UPDATE_TESTIMONY_CATEGORY_REQUEST = "UPDATE_TESTIMONY_CATEGORY_REQUEST";
export const READ_TESTIMONY_REQUEST = "READ_TESTIMONY_REQUEST";
export const POST_ACCEPT_TESTIMONY_REQUEST = "POST_ACCEPT_TESTIMONY_REQUEST";
export const POST_REJECT_TESTIMONY_REQUEST = "POST_REJECT_TESTIMONY_REQUEST";
export const POST_TESTIMONY_OF_THE_DAY_REQUEST = "POST_TESTIMONY_OF_THE_DAY_REQUEST";

export const GET_GIVINGS_LIST_REQUEST = "GET_GIVINGS_LIST_REQUEST";
export const GET_USER_PROFILE_REQUEST = "GET_USER_PROFILE_REQUEST";
export const GET_USER_TRANSACTIONS_REQEST = "GET_USER_TRANSACTIONS_REQEST";
export const POST_REFUND_REQUEST = "POST_REFUND_REQUEST";

export const GET_USERS_FOR_NOTIFICATIONS_REQUEST = "GET_USERS_FOR_NOTIFICATIONS_REQUEST";
export const SEND_NOTIFICATION_REQUEST = "SEND_NOTIFICATION_REQUEST";
export const SEND_CUSTOM_NOTIFICATION_REQUEST = "SEND_CUSTOM_NOTIFICATION_REQUEST";
export const GET_LIST_OF_NOTIFICATIONS_REQEST = "GET_LIST_OF_NOTIFICATIONS_REQEST";
export const DELETE_NOTIFICATION_REQUEST = "DELETE_NOTIFICATION_REQUEST";

export const GET_LIST_OF_FEEDBACK_REQEST = "GET_LIST_OF_FEEDBACK_REQEST";
export const GET_LIST_OF_PRAYER_REQEST = "GET_LIST_OF_PRAYER_REQEST";

export const SAVE_TWG_REQUEST = "SAVE_TWG_REQUEST";
export const GET_LIST_TWG_REQUEST = "GET_LIST_TWG_REQUEST";
export const UPDATE_TWG_REQUEST = "UPDATE_TWG_REQUEST";

export const GET_ROLES_REQUEST = "GET_ROLES_REQUEST";
export const SAVE_CMS_USER_REQUEST = "SAVE_CMS_USER_REQUEST";
export const GET_CMS_USER_REQUEST = "GET_CMS_USER_REQUEST";
export const UPDATE_CMS_USER_REQUEST = "UPDATE_CMS_USER_REQUEST";
export const DELETE_CMS_USER_REQUEST = "DELETE_CMS_USER_REQUEST";

export const SAVE_PROMISE_REQUEST = "SAVE_PROMISE_REQUEST";
export const SAVE_PROMISE_LANGUAGE_REQUEST = "SAVE_PROMISE_LANGUAGE_REQUEST";
export const UPDATE_PROMISE_REQUEST = "UPDATE_PROMISE_REQUEST";
export const UPDATE_PROMISE_LANGUAGE_REQUEST = "UPDATE_PROMISE_LANGUAGE_REQUEST";
export const DELETE_PROMISE_REQUEST = "DELETE_PROMISE_REQUEST";
export const READ_PROMISE_REQUEST = "READ_PROMISE_REQUEST";
export const READ_CMS_PROMISE_REQUEST = "READ_CMS_PROMISE_REQUEST";

export const SAVE_PROMISE_BG_REQUEST = "SAVE_PROMISE_BG_REQUEST";
export const UPDATE_PROMISE_BG_REQUEST = "UPDATE_PROMISE_BG_REQUEST";
export const DELETE_PROMISE_BG_REQUEST = "DELETE_PROMISE_BG_REQUEST";

export const SAVE_PROMISE_COMMON_BG_REQUEST = "SAVE_PROMISE_COMMON_BG_REQUEST";
export const UPDATE_PROMISE_COMMON_BG_REQUEST = "UPDATE_PROMISE_COMMON_BG_REQUEST";
export const DELETE_PROMISE_COMMON_BG_REQUEST = "DELETE_PROMISE_COMMON_BG_REQUEST";

export const SAVE_PROMISE_THUMBNAIL_REQUEST = "SAVE_PROMISE_THUMBNAIL_REQUEST";
export const UPDATE_PROMISE_THUMBNAIL_REQUEST = "UPDATE_PROMISE_THUMBNAIL_REQUEST";
export const DELETE_PROMISE_THUMBNAIL_REQUEST = "DELETE_PROMISE_THUMBNAIL_REQUEST";

export const SAVE_PROMISE_COMMON_THUMBNAIL_REQUEST = "SAVE_PROMISE_COMMON_THUMBNAIL_REQUEST";
export const UPDATE_PROMISE_COMMON_THUMBNAIL_REQUEST = "UPDATE_PROMISE_COMMON_THUMBNAIL_REQUEST";
export const DELETE_PROMISE_COMMON_THUMBNAIL_REQUEST = "DELETE_PROMISE_COMMON_THUMBNAIL_REQUEST";

export const SAVE_PROMISE_HWGIMAGE_REQUEST = "SAVE_PROMISE_HWGIMAGE_REQUEST";
export const UPDATE_PROMISE_HWGIMAGE_REQUEST = "UPDATE_PROMISE_HWGIMAGE_REQUEST";
export const DELETE_PROMISE_HWGIMAGE_REQUEST = "DELETE_PROMISE_HWGIMAGE_REQUEST";

export const SAVE_PROMISE_AUDIO_REQUEST = "SAVE_PROMISE_AUDIO_REQUEST";
export const SAVE_PROMISE_AUDIO_LANGUAGE_REQUEST = "SAVE_PROMISE_AUDIO_LANGUAGE_REQUEST";
export const UPDATE_PROMISE_AUDIO_REQUEST = "UPDATE_PROMISE_AUDIO_REQUEST";
export const UPDATE_PROMISE_AUDIO_LANGUAGE_REQUEST = "UPDATE_PROMISE_AUDIO_LANGUAGE_REQUEST";
export const DELETE_PROMISE_AUDIO_REQUEST = "DELETE_PROMISE_AUDIO_REQUEST";

export const SAVE_PROMISE_VIDEO_REQUEST = "SAVE_PROMISE_VIDEO_REQUEST";
export const SAVE_PROMISE_VIDEO_LANGUAGE_REQUEST = "SAVE_PROMISE_VIDEO_LANGUAGE_REQUEST";
export const UPDATE_PROMISE_VIDEO_REQUEST = "UPDATE_PROMISE_VIDEO_REQUEST";
export const UPDATE_PROMISE_VIDEO_LANGUAGE_REQUEST = "UPDATE_PROMISE_VIDEO_LANGUAGE_REQUEST";
export const DELETE_PROMISE_VIDEO_REQUEST = "DELETE_PROMISE_VIDEO_REQUEST";


export const SET_SELECTED_TAB = "SET_SELECTED_TAB";
export const SAVE_SELECTED_TAB = "SAVE_SELECTED_TAB";


//Church
export const FETCH_CHURCHES_REQUEST = "FETCH_CHURCHES_REQUEST";
export const FETCH_CHURCHES_SUCCESS = "FETCH_CHURCHES_SUCCESS";
export const FETCH_CHURCHES_FAILURE = "FETCH_CHURCHES_FAILURE";

export const SAVE_CHURCH_REQUEST = "SAVE_CHURCH_REQUEST";
export const SAVE_CHURCH_SUCCESS = "SAVE_CHURCH_SUCCESS";
export const SAVE_CHURCH_FAILURE = "SAVE_CHURCH_FAILURE";

export const DELETE_CHURCH_REQUEST = "DELETE_CHURCH_REQUEST";
export const DELETE_CHURCH_SUCCESS = "DELETE_CHURCH_SUCCESS";
export const DELETE_CHURCH_FAILURE = "DELETE_CHURCH_FAILURE";

export const UPDATE_CHURCH_REQUEST = "UPDATE_CHURCH_REQUEST";
export const UPDATE_CHURCH_SUCCESS = "UPDATE_CHURCH_SUCCESS";
export const UPDATE_CHURCH_FAILURE = "UPDATE_CHURCH_FAILURE";

export const ASSIGN_CHURCH_ADMIN_REQUEST = "ASSIGN_CHURCH_ADMIN_REQUEST";
export const ASSIGN_CHURCH_ADMIN_SUCCESS = "ASSIGN_CHURCH_ADMIN_SUCCESS";
export const ASSIGN_CHURCH_ADMIN_FAILURE = "ASSIGN_CHURCH_ADMIN_FAILURE";

export const FETCH_CHURCH_BY_ID_REQUEST = "FETCH_CHURCH_BY_ID_REQUEST";
export const FETCH_CHURCH_BY_ID_SUCCESS = "FETCH_CHURCH_BY_ID_SUCCESS";
export const FETCH_CHURCH_BY_ID_FAILURE = "FETCH_CHURCH_BY_ID_FAILURE";
 
// 🏛️ Church Cover Image
export const SAVE_CHURCH_COVERIMAGE_REQUEST = "SAVE_CHURCH_COVERIMAGE_REQUEST";
export const SAVE_CHURCH_COVERIMAGE_SUCCESS = "SAVE_CHURCH_COVERIMAGE_SUCCESS";
export const SAVE_CHURCH_COVERIMAGE_FAILURE = "SAVE_CHURCH_COVERIMAGE_FAILURE";

export const UPDATE_CHURCH_COVERIMAGE_REQUEST = "UPDATE_CHURCH_COVERIMAGE_REQUEST";
export const UPDATE_CHURCH_COVERIMAGE_SUCCESS = "UPDATE_CHURCH_COVERIMAGE_SUCCESS";
export const UPDATE_CHURCH_COVERIMAGE_FAILURE = "UPDATE_CHURCH_COVERIMAGE_FAILURE";
export const DELETE_CHURCH_COVERIMAGE_REQUEST = "DELETE_CHURCH_COVERIMAGE_REQUEST";
export const DELETE_CHURCH_COVERIMAGE_SUCCESS = "DELETE_CHURCH_COVERIMAGE_SUCCESS";
export const DELETE_CHURCH_COVERIMAGE_FAILURE = "DELETE_CHURCH_COVERIMAGE_FAILURE";


//Carecrell
export const FETCH_CARECELLS_REQUEST = "FETCH_CARECELLS_REQUEST";
export const FETCH_CARECELLS_SUCCESS = "FETCH_CARECELLS_SUCCESS";
export const FETCH_CARECELLS_FAILURE = "FETCH_CARECELLS_FAILURE";

export const SAVE_CARECELL_REQUEST = "SAVE_CARECELL_REQUEST";
export const SAVE_CARECELL_SUCCESS = "SAVE_CARECELL_SUCCESS";
export const SAVE_CARECELL_FAILURE = "SAVE_CARECELL_FAILURE";

export const UPDATE_CARECELL_REQUEST = "UPDATE_CARECELL_REQUEST";
export const UPDATE_CARECELL_SUCCESS = "UPDATE_CARECELL_SUCCESS";
export const UPDATE_CARECELL_FAILURE = "UPDATE_CARECELL_FAILURE";

export const DELETE_CARECELL_REQUEST = "DELETE_CARECELL_REQUEST";
export const DELETE_CARECELL_SUCCESS = "DELETE_CARECELL_SUCCESS";
export const DELETE_CARECELL_FAILURE = "DELETE_CARECELL_FAILURE";

export const FETCH_CARECELL_BY_ID_REQUEST = "FETCH_CARECELL_BY_ID_REQUEST";
export const FETCH_CARECELL_BY_ID_SUCCESS = "FETCH_CARECELL_BY_ID_SUCCESS";
export const FETCH_CARECELL_BY_ID_FAILURE = "FETCH_CARECELL_BY_ID_FAILURE";

//  CARECELL COVER IMAGES

export const SAVE_CARECELL_COVERIMAGE_REQUEST = "SAVE_CARECELL_COVERIMAGE_REQUEST";
export const SAVE_CARECELL_COVERIMAGE_SUCCESS = "SAVE_CARECELL_COVERIMAGE_SUCCESS";
export const SAVE_CARECELL_COVERIMAGE_FAILURE = "SAVE_CARECELL_COVERIMAGE_FAILURE";

export const UPDATE_CARECELL_COVERIMAGE_REQUEST = "UPDATE_CARECELL_COVERIMAGE_REQUEST";
export const UPDATE_CARECELL_COVERIMAGE_SUCCESS = "UPDATE_CARECELL_COVERIMAGE_SUCCESS";
export const UPDATE_CARECELL_COVERIMAGE_FAILURE = "UPDATE_CARECELL_COVERIMAGE_FAILURE";

export const DELETE_CARECELL_COVERIMAGE_REQUEST = "DELETE_CARECELL_COVERIMAGE_REQUEST";
export const DELETE_CARECELL_COVERIMAGE_SUCCESS = "DELETE_CARECELL_COVERIMAGE_SUCCESS";
export const DELETE_CARECELL_COVERIMAGE_FAILURE = "DELETE_CARECELL_COVERIMAGE_FAILURE";

//Team
// TEAM ACTION TYPES
export const FETCH_TEAM_REQUEST = "FETCH_TEAM_REQUEST";
export const FETCH_TEAM_SUCCESS = "FETCH_TEAM_SUCCESS";
export const FETCH_TEAM_FAILURE = "FETCH_TEAM_FAILURE";

export const SAVE_TEAM_REQUEST = "SAVE_TEAM_REQUEST";
export const SAVE_TEAM_SUCCESS = "SAVE_TEAM_SUCCESS";
export const SAVE_TEAM_FAILURE = "SAVE_TEAM_FAILURE";

export const UPDATE_TEAM_REQUEST = "UPDATE_TEAM_REQUEST";
export const UPDATE_TEAM_SUCCESS = "UPDATE_TEAM_SUCCESS";
export const UPDATE_TEAM_FAILURE = "UPDATE_TEAM_FAILURE";

export const DELETE_TEAM_REQUEST = "DELETE_TEAM_REQUEST";
export const DELETE_TEAM_SUCCESS = "DELETE_TEAM_SUCCESS";
export const DELETE_TEAM_FAILURE = "DELETE_TEAM_FAILURE";

// 🔹 TEAM COVER IMAGE
export const SAVE_TEAM_COVERIMAGE_REQUEST = "SAVE_TEAM_COVERIMAGE_REQUEST";
export const SAVE_TEAM_COVERIMAGE_SUCCESS = "SAVE_TEAM_COVERIMAGE_SUCCESS";
export const SAVE_TEAM_COVERIMAGE_FAILURE = "SAVE_TEAM_COVERIMAGE_FAILURE";

export const UPDATE_TEAM_COVERIMAGE_REQUEST = "UPDATE_TEAM_COVERIMAGE_REQUEST";
export const UPDATE_TEAM_COVERIMAGE_SUCCESS = "UPDATE_TEAM_COVERIMAGE_SUCCESS";
export const UPDATE_TEAM_COVERIMAGE_FAILURE = "UPDATE_TEAM_COVERIMAGE_FAILURE";

export const DELETE_TEAM_COVERIMAGE_REQUEST = "DELETE_TEAM_COVERIMAGE_REQUEST";
export const DELETE_TEAM_COVERIMAGE_SUCCESS = "DELETE_TEAM_COVERIMAGE_SUCCESS";
export const DELETE_TEAM_COVERIMAGE_FAILURE = "DELETE_TEAM_COVERIMAGE_FAILURE";


//Gallery Image
// ✅ Gallery Action Types
export const SAVE_GALLERY_REQUEST = "SAVE_GALLERY_REQUEST";
export const SAVE_GALLERY_SUCCESS = "SAVE_GALLERY_SUCCESS";
export const SAVE_GALLERY_FAILURE = "SAVE_GALLERY_FAILURE";

export const READ_GALLERY_REQUEST = "READ_GALLERY_REQUEST";
export const READ_GALLERY_SUCCESS = "READ_GALLERY_SUCCESS";
export const READ_GALLERY_FAILURE = "READ_GALLERY_FAILURE";

export const DELETE_GALLERY_REQUEST = "DELETE_GALLERY_REQUEST";
export const DELETE_GALLERY_SUCCESS = "DELETE_GALLERY_SUCCESS";
export const DELETE_GALLERY_FAILURE = "DELETE_GALLERY_FAILURE";

export const UPDATE_GALLERY_IMAGE_REQUEST = "UPDATE_GALLERY_IMAGE_REQUEST";
export const UPDATE_GALLERY_IMAGE_SUCCESS = "UPDATE_GALLERY_IMAGE_SUCCESS";
export const UPDATE_GALLERY_IMAGE_FAILURE = "UPDATE_GALLERY_IMAGE_FAILURE";


//Resources
// Resources Action Types

export const FETCH_RESOURCES_REQUEST = "FETCH_RESOURCES_REQUEST";
export const FETCH_RESOURCES_SUCCESS = "FETCH_RESOURCES_SUCCESS";
export const FETCH_RESOURCES_FAILURE = "FETCH_RESOURCES_FAILURE";

export const SAVE_RESOURCE_REQUEST = "SAVE_RESOURCE_REQUEST";
export const SAVE_RESOURCE_SUCCESS = "SAVE_RESOURCE_SUCCESS";
export const SAVE_RESOURCE_FAILURE = "SAVE_RESOURCE_FAILURE";

export const UPDATE_RESOURCE_REQUEST = "UPDATE_RESOURCE_REQUEST";
export const UPDATE_RESOURCE_SUCCESS = "UPDATE_RESOURCE_SUCCESS";
export const UPDATE_RESOURCE_FAILURE = "UPDATE_RESOURCE_FAILURE";

export const DELETE_RESOURCE_REQUEST = "DELETE_RESOURCE_REQUEST";
export const DELETE_RESOURCE_SUCCESS = "DELETE_RESOURCE_SUCCESS";
export const DELETE_RESOURCE_FAILURE = "DELETE_RESOURCE_FAILURE";


//Program
// Action Types
export const SAVE_PROGRAM_REQUEST = "SAVE_PROGRAM_REQUEST";
export const SAVE_PROGRAM_SUCCESS = "SAVE_PROGRAM_SUCCESS";
export const SAVE_PROGRAM_FAILURE = "SAVE_PROGRAM_FAILURE";

export const UPDATE_PROGRAM_REQUEST = "UPDATE_PROGRAM_REQUEST";
export const UPDATE_PROGRAM_SUCCESS = "UPDATE_PROGRAM_SUCCESS";
export const UPDATE_PROGRAM_FAILURE = "UPDATE_PROGRAM_FAILURE";

export const DELETE_PROGRAM_REQUEST = "DELETE_PROGRAM_REQUEST";
export const DELETE_PROGRAM_SUCCESS = "DELETE_PROGRAM_SUCCESS";
export const DELETE_PROGRAM_FAILURE = "DELETE_PROGRAM_FAILURE";
export const SAVE_PROGRAM_COVERIMAGE_REQUEST = "SAVE_PROGRAM_COVERIMAGE_REQUEST";
export const SAVE_PROGRAM_COVERIMAGE_SUCCESS = "SAVE_PROGRAM_COVERIMAGE_SUCCESS";
export const SAVE_PROGRAM_COVERIMAGE_FAILURE = "SAVE_PROGRAM_COVERIMAGE_FAILURE";

export const UPDATE_PROGRAM_COVERIMAGE_REQUEST = "UPDATE_PROGRAM_COVERIMAGE_REQUEST";
export const UPDATE_PROGRAM_COVERIMAGE_SUCCESS = "UPDATE_PROGRAM_COVERIMAGE_SUCCESS";
export const UPDATE_PROGRAM_COVERIMAGE_FAILURE = "UPDATE_PROGRAM_COVERIMAGE_FAILURE";

export const DELETE_PROGRAM_COVERIMAGE_REQUEST = "DELETE_PROGRAM_COVERIMAGE_REQUEST";
export const DELETE_PROGRAM_COVERIMAGE_SUCCESS = "DELETE_PROGRAM_COVERIMAGE_SUCCESS";
export const DELETE_PROGRAM_COVERIMAGE_FAILURE = "DELETE_PROGRAM_COVERIMAGE_FAILURE";

//Bulletin
export const SAVE_BULLETIN_REQUEST = "SAVE_BULLETIN_REQUEST";
export const SAVE_BULLETIN_SUCCESS = "SAVE_BULLETIN_SUCCESS";
export const SAVE_BULLETIN_FAILURE = "SAVE_BULLETIN_FAILURE";
export const UPDATE_BULLETIN_REQUEST = "UPDATE_BULLETIN_REQUEST";
export const UPDATE_BULLETIN_SUCCESS = "UPDATE_BULLETIN_SUCCESS";
export const UPDATE_BULLETIN_FAILURE = "UPDATE_BULLETIN_FAILURE";
export const DELETE_BULLETIN_REQUEST = "DELETE_BULLETIN_REQUEST";
export const DELETE_BULLETIN_SUCCESS = "DELETE_BULLETIN_SUCCESS";
export const DELETE_BULLETIN_FAILURE = "DELETE_BULLETIN_FAILURE";

export const SAVE_BULLETIN_COVERIMAGE_REQUEST = "SAVE_BULLETIN_COVERIMAGE_REQUEST";
export const SAVE_BULLETIN_COVERIMAGE_SUCCESS = "SAVE_BULLETIN_COVERIMAGE_SUCCESS";
export const SAVE_BULLETIN_COVERIMAGE_FAILURE = "SAVE_BULLETIN_COVERIMAGE_FAILURE";
export const UPDATE_BULLETIN_COVERIMAGE_REQUEST = "UPDATE_BULLETIN_COVERIMAGE_REQUEST";
export const UPDATE_BULLETIN_COVERIMAGE_SUCCESS = "UPDATE_BULLETIN_COVERIMAGE_SUCCESS";
export const UPDATE_BULLETIN_COVERIMAGE_FAILURE = "UPDATE_BULLETIN_COVERIMAGE_FAILURE";
export const DELETE_BULLETIN_COVERIMAGE_REQUEST = "DELETE_BULLETIN_COVERIMAGE_REQUEST";
export const DELETE_BULLETIN_COVERIMAGE_SUCCESS = "DELETE_BULLETIN_COVERIMAGE_SUCCESS";
export const DELETE_BULLETIN_COVERIMAGE_FAILURE = "DELETE_BULLETIN_COVERIMAGE_FAILURE";




// Campuses
export const SAVE_CAMPUS_REQUEST = "SAVE_CAMPUS_REQUEST";
export const SAVE_CAMPUS_SUCCESS = "SAVE_CAMPUS_SUCCESS";
export const SAVE_CAMPUS_FAILURE = "SAVE_CAMPUS_FAILURE";
export const DELETE_CAMPUS_REQUEST = "DELETE_CAMPUS_REQUEST";
export const DELETE_CAMPUS_SUCCESS = "DELETE_CAMPUS_SUCCESS";
export const DELETE_CAMPUS_FAILURE = "DELETE_CAMPUS_FAILURE";
export const UPDATE_CAMPUS_REQUEST="UPDATE_CAMPUS_REQUEST";
export const UPDATE_CAMPUS_SUCCESS="UPDATE_CAMPUS_SUCCESS";
export const UPDATE_CAMPUS_FAILURE="UPDATE_CAMPUS_FAILURE";
export const SAVE_CAMPUS_GALLERY_REQUEST = "SAVE_CAMPUS_GALLERY_REQUEST";
export const SAVE_CAMPUS_GALLERY_SUCCESS = "SAVE_CAMPUS_GALLERY_SUCCESS";
export const SAVE_CAMPUS_GALLERY_FAILURE = "SAVE_CAMPUS_GALLERY_FAILURE";
export const UPDATE_CAMPUS_GALLERY_REQUEST = "UPDATE_CAMPUS_GALLERY_REQUEST";
export const UPDATE_CAMPUS_GALLERY_SUCCESS = "UPDATE_CAMPUS_GALLERY_SUCCESS";
export const UPDATE_CAMPUS_GALLERY_FAILURE = "UPDATE_CAMPUS_GALLERY_FAILURE";
export const DELETE_CAMPUS_GALLERY_REQUEST = "DELETE_CAMPUS_GALLERY_REQUEST";
export const DELETE_CAMPUS_GALLERY_SUCCESS = "DELETE_CAMPUS_GALLERY_SUCCESS";
export const DELETE_CAMPUS_GALLERY_FAILURE = "DELETE_CAMPUS_GALLERY_FAILURE";


//service
// 🔹 Services
export const SAVE_SERVICE_REQUEST = "SAVE_SERVICE_REQUEST";
export const SAVE_SERVICE_SUCCESS = "SAVE_SERVICE_SUCCESS";
export const SAVE_SERVICE_FAILURE = "SAVE_SERVICE_FAILURE";
export const SAVE_CAMPUS_TIME_REQUEST = "SAVE_CAMPUS_TIME_REQUEST";
export const SAVE_CAMPUS_TIME_SUCCESS = "SAVE_CAMPUS_TIME_SUCCESS";
export const SAVE_CAMPUS_TIME_FAILURE = "SAVE_CAMPUS_TIME_FAILURE";
export const SAVE_SERVICE_GALLERY_REQUEST = "SAVE_SERVICE_GALLERY_REQUEST";
export const SAVE_SERVICE_GALLERY_SUCCESS = "SAVE_SERVICE_GALLERY_SUCCESS";
export const SAVE_SERVICE_GALLERY_FAILURE = "SAVE_SERVICE_GALLERY_FAILURE";
export const DELETE_SERVICE_REQUEST = "DELETE_SERVICE_REQUEST";
export const DELETE_SERVICE_SUCCESS = "DELETE_SERVICE_SUCCESS";
export const DELETE_SERVICE_FAILURE = "DELETE_SERVICE_FAILURE";
export const UPDATE_SERVICE_REQUEST = "UPDATE_SERVICE_REQUEST";
export const UPDATE_SERVICE_SUCCESS = "UPDATE_SERVICE_SUCCESS";
export const UPDATE_SERVICE_FAILURE = "UPDATE_SERVICE_FAILURE";
export const UPDATE_CAMPUS_TIME_REQUEST = "UPDATE_CAMPUS_TIME_REQUEST";
export const UPDATE_CAMPUS_TIME_SUCCESS = "UPDATE_CAMPUS_TIME_SUCCESS";
export const UPDATE_CAMPUS_TIME_FAILURE = "UPDATE_CAMPUS_TIME_FAILURE";
export const UPDATE_SERVICE_GALLERY_REQUEST = "UPDATE_SERVICE_GALLERY_REQUEST";
export const UPDATE_SERVICE_GALLERY_SUCCESS = "UPDATE_SERVICE_GALLERY_SUCCESS";
export const UPDATE_SERVICE_GALLERY_FAILURE = "UPDATE_SERVICE_GALLERY_FAILURE";

export const DELETE_SERVICE_GALLERY_REQUEST = "DELETE_SERVICE_GALLERY_REQUEST";
export const DELETE_SERVICE_GALLERY_SUCCESS = "DELETE_SERVICE_GALLERY_SUCCESS";
export const DELETE_SERVICE_GALLERY_FAILURE = "DELETE_SERVICE_GALLERY_FAILURE";

export const DELETE_CAMPUS_TIME_REQUEST = "DELETE_CAMPUS_TIME_REQUEST";
export const DELETE_CAMPUS_TIME_SUCCESS = "DELETE_CAMPUS_TIME_SUCCESS";
export const DELETE_CAMPUS_TIME_FAILURE = "DELETE_CAMPUS_TIME_FAILURE";
//Church Language
// 🔹 Language Meta
export const SAVE_LANGUAGE_META_REQUEST = "SAVE_LANGUAGE_META_REQUEST";
export const SAVE_LANGUAGE_META_SUCCESS = "SAVE_LANGUAGE_META_SUCCESS";
export const SAVE_LANGUAGE_META_FAILURE = "SAVE_LANGUAGE_META_FAILURE";

//Program Language
// 🔹 Language Meta
export const SAVE_PROGRAM_LANGUAGE_META_REQUEST = "SAVE_PROGRAM_LANGUAGE_META_REQUEST";
export const SAVE_PROGRAM_LANGUAGE_META_SUCCESS = "SAVE_PROGRAM_LANGUAGE_META_SUCCESS";
export const SAVE_PROGRAM_LANGUAGE_META_FAILURE = "SAVE_PROGRAM_LANGUAGE_META_FAILURE";


// 🔹 Fetch Ministries
export const FETCH_MINISTRIES_REQUEST = "FETCH_MINISTRIES_REQUEST";
export const FETCH_MINISTRIES_SUCCESS = "FETCH_MINISTRIES_SUCCESS";
export const FETCH_MINISTRIES_FAILURE = "FETCH_MINISTRIES_FAILURE";

// 🔹 Save Ministry
export const SAVE_MINISTRY_REQUEST = "SAVE_MINISTRY_REQUEST";
export const SAVE_MINISTRY_SUCCESS = "SAVE_MINISTRY_SUCCESS";
export const SAVE_MINISTRY_FAILURE = "SAVE_MINISTRY_FAILURE";

// 🔹 Delete Ministry
export const DELETE_MINISTRY_REQUEST = "DELETE_MINISTRY_REQUEST";
export const DELETE_MINISTRY_SUCCESS = "DELETE_MINISTRY_SUCCESS";
export const DELETE_MINISTRY_FAILURE = "DELETE_MINISTRY_FAILURE";

// 🔹 Update Ministry
export const UPDATE_MINISTRY_REQUEST = "UPDATE_MINISTRY_REQUEST";
export const UPDATE_MINISTRY_SUCCESS = "UPDATE_MINISTRY_SUCCESS";
export const UPDATE_MINISTRY_FAILURE = "UPDATE_MINISTRY_FAILURE";

// 🔹 Fetch Ministry by ID
export const FETCH_MINISTRY_BY_ID_REQUEST = "FETCH_MINISTRY_BY_ID_REQUEST";
export const FETCH_MINISTRY_BY_ID_SUCCESS = "FETCH_MINISTRY_BY_ID_SUCCESS";
export const FETCH_MINISTRY_BY_ID_FAILURE = "FETCH_MINISTRY_BY_ID_FAILURE";

export const FETCH_CHANNELS_REQUEST = "FETCH_CHANNELS_REQUEST";
export const FETCH_CHANNELS_SUCCESS = "FETCH_CHANNELS_SUCCESS";
export const FETCH_CHANNELS_FAILURE = "FETCH_CHANNELS_FAILURE";

export const SAVE_CHANNEL_REQUEST = "SAVE_CHANNEL_REQUEST";
export const SAVE_CHANNEL_SUCCESS = "SAVE_CHANNEL_SUCCESS";
export const SAVE_CHANNEL_FAILURE = "SAVE_CHANNEL_FAILURE";

export const DELETE_CHANNEL_REQUEST = "DELETE_CHANNEL_REQUEST";
export const DELETE_CHANNEL_SUCCESS = "DELETE_CHANNEL_SUCCESS";
export const DELETE_CHANNEL_FAILURE = "DELETE_CHANNEL_FAILURE";

export const UPDATE_CHANNEL_REQUEST = "UPDATE_CHANNEL_REQUEST";
export const UPDATE_CHANNEL_SUCCESS = "UPDATE_CHANNEL_SUCCESS";
export const UPDATE_CHANNEL_FAILURE = "UPDATE_CHANNEL_FAILURE";

export const FETCH_CHANNEL_BY_ID_REQUEST = "FETCH_CHANNEL_BY_ID_REQUEST";
export const FETCH_CHANNEL_BY_ID_SUCCESS = "FETCH_CHANNEL_BY_ID_SUCCESS";
export const FETCH_CHANNEL_BY_ID_FAILURE = "FETCH_CHANNEL_BY_ID_FAILURE";


//Team Language
export const SAVE_LEADERSHIP_LANGUAGE_META_REQUEST = "SAVE_LEADERSHIP_LANGUAGE_META_REQUEST";
export const SAVE_LEADERSHIP_LANGUAGE_META_FAILURE = "SAVE_LEADERSHIP_LANGUAGE_META_FAILURE";
export const SAVE_LEADERSHIP_LANGUAGE_META_SUCCESS = "SAVE_LEADERSHIP_LANGUAGE_META_SUCCESS";

//Give setting
export const SAVE_GIVESETTING_REQUEST = "SAVE_GIVESETTING_REQUEST";
export const SAVE_GIVESETTING_FAILURE = "SAVE_GIVESETTING_FAILURE";
export const SAVE_GIVESETTING_SUCCESS = "SAVE_GIVESETTING_SUCCESS";
export const UPDATE_GIVESETTING_REQUEST = "UPDATE_GIVESETTING_REQUEST";
export const UPDATE_GIVESETTING_FAILURE = "UPDATE_GIVESETTING_FAILURE";
export const UPDATE_GIVESETTING_SUCCESS = "UPDATE_GIVESETTING_SUCCESS";
export const DELETE_GIVESETTING_REQUEST = "DELETE_GIVESETTING_REQUEST";
export const DELETE_GIVESETTING_FAILURE = "DELETE_GIVESETTING_FAILURE";
export const DELETE_GIVESETTING_SUCCESS = "DELETE_GIVESETTING_SUCCESS";


export const SAVE_VIDEO_REQUEST = "SAVE_VIDEO_REQUEST";
export const SAVE_VIDEO_SUCCESS = "SAVE_VIDEO_SUCCESS";
export const SAVE_VIDEO_FAILURE = "SAVE_VIDEO_FAILURE";

export const UPDATE_VIDEO_REQUEST = "UPDATE_VIDEO_REQUEST";
export const UPDATE_VIDEO_SUCCESS = "UPDATE_VIDEO_SUCCESS";
export const UPDATE_VIDEO_FAILURE = "UPDATE_VIDEO_FAILURE";

export const DELETE_VIDEO_REQUEST = "DELETE_VIDEO_REQUEST";
export const DELETE_VIDEO_SUCCESS = "DELETE_VIDEO_SUCCESS";
export const DELETE_VIDEO_FAILURE = "DELETE_VIDEO_FAILURE";

export const READ_VIDEO_REQUEST = "READ_VIDEO_REQUEST";
export const READ_VIDEO_SUCCESS = "READ_VIDEO_SUCCESS";
export const READ_VIDEO_FAILURE = "READ_VIDEO_FAILURE";


export const SAVE_CHURCH_VIDEO_REQUEST = "SAVE_CHURCH_VIDEO_REQUEST";
export const UPDATE_CHURCH_VIDEO_REQUEST = "UPDATE_CHURCH_VIDEO_REQUEST";
export const DELETE_CHURCH_VIDEO_REQUEST = "DELETE_CHURCH_VIDEO_REQUEST";

export const SAVE_CHURCH_VIDEO_SUCCESS = "SAVE_CHURCH_VIDEO_REQUEST";
export const SAVE_CHURCH_VIDEO_FAILURE = "UPDATE_CHURCH_VIDEO_REQUEST";
export const UPDATE_CHURCH_VIDEO_SUCCESS = "DELETE_CHURCH_VIDEO_REQUEST";

export const UPDATE_CHURCH_VIDEO_FAILURE = "SAVE_CHURCH_VIDEO_REQUEST";
export const DELETE_CHURCH_VIDEO_SUCCESS = "UPDATE_CHURCH_VIDEO_REQUEST";
export const DELETE_CHURCH_VIDEO_FAILURE = "DELETE_CHURCH_VIDEO_REQUEST";




export const READ_CHURCH_VIDEO_REQUEST = "READ_CHURCH_VIDEO_REQUEST";
export const READ_CHURCH_VIDEO_SUCCESS = "READ_CHURCH_VIDEO_SUCCESS";
export const READ_CHURCH_VIDEO_FAILURE = "READ_CHURCH_VIDEO_FAILURE";


//Bulletin Video

// Bulletin Video Action Types
export const SAVE_BULLETIN_VIDEO_REQUEST = "SAVE_BULLETIN_VIDEO_REQUEST";
export const SAVE_BULLETIN_VIDEO_SUCCESS = "SAVE_BULLETIN_VIDEO_SUCCESS";
export const SAVE_BULLETIN_VIDEO_FAILURE = "SAVE_BULLETIN_VIDEO_FAILURE";

export const UPDATE_BULLETIN_VIDEO_REQUEST = "UPDATE_BULLETIN_VIDEO_REQUEST";
export const UPDATE_BULLETIN_VIDEO_SUCCESS = "UPDATE_BULLETIN_VIDEO_SUCCESS";
export const UPDATE_BULLETIN_VIDEO_FAILURE = "UPDATE_BULLETIN_VIDEO_FAILURE";

export const DELETE_BULLETIN_VIDEO_REQUEST = "DELETE_BULLETIN_VIDEO_REQUEST";
export const DELETE_BULLETIN_VIDEO_SUCCESS = "DELETE_BULLETIN_VIDEO_SUCCESS";
export const DELETE_BULLETIN_VIDEO_FAILURE = "DELETE_BULLETIN_VIDEO_FAILURE";

export const READ_BULLETIN_VIDEO_REQUEST = "READ_BULLETIN_VIDEO_REQUEST";
export const READ_BULLETIN_VIDEO_SUCCESS = "READ_BULLETIN_VIDEO_SUCCESS";
export const READ_BULLETIN_VIDEO_FAILURE = "READ_BULLETIN_VIDEO_FAILURE";

//Program Video
export const SAVE_PROGRAM_VIDEO_REQUEST = "SAVE_PROGRAM_VIDEO_REQUEST";
export const SAVE_PROGRAM_VIDEO_SUCCESS = "SAVE_PROGRAM_VIDEO_SUCCESS";
export const SAVE_PROGRAM_VIDEO_FAILURE = "SAVE_PROGRAM_VIDEO_FAILURE";

// UPDATE
export const UPDATE_PROGRAM_VIDEO_REQUEST = "UPDATE_PROGRAM_VIDEO_REQUEST";
export const UPDATE_PROGRAM_VIDEO_SUCCESS = "UPDATE_PROGRAM_VIDEO_SUCCESS";
export const UPDATE_PROGRAM_VIDEO_FAILURE = "UPDATE_PROGRAM_VIDEO_FAILURE";

// DELETE
export const DELETE_PROGRAM_VIDEO_REQUEST = "DELETE_PROGRAM_VIDEO_REQUEST";
export const DELETE_PROGRAM_VIDEO_SUCCESS = "DELETE_PROGRAM_VIDEO_SUCCESS";
export const DELETE_PROGRAM_VIDEO_FAILURE = "DELETE_PROGRAM_VIDEO_FAILURE";

// READ
export const READ_PROGRAM_VIDEO_REQUEST = "READ_PROGRAM_VIDEO_REQUEST";
export const READ_PROGRAM_VIDEO_SUCCESS = "READ_PROGRAM_VIDEO_SUCCESS";
export const READ_PROGRAM_VIDEO_FAILURE = "READ_PROGRAM_VIDEO_FAILURE";

// RESOURCE VIDEOS
export const SAVE_RESOURCE_VIDEO_REQUEST = "SAVE_RESOURCE_VIDEO_REQUEST";
export const SAVE_RESOURCE_VIDEO_SUCCESS = "SAVE_RESOURCE_VIDEO_SUCCESS";
export const SAVE_RESOURCE_VIDEO_FAILURE = "SAVE_RESOURCE_VIDEO_FAILURE";

export const UPDATE_RESOURCE_VIDEO_REQUEST = "UPDATE_RESOURCE_VIDEO_REQUEST";
export const UPDATE_RESOURCE_VIDEO_SUCCESS = "UPDATE_RESOURCE_VIDEO_SUCCESS";
export const UPDATE_RESOURCE_VIDEO_FAILURE = "UPDATE_RESOURCE_VIDEO_FAILURE";

export const DELETE_RESOURCE_VIDEO_REQUEST = "DELETE_RESOURCE_VIDEO_REQUEST";
export const DELETE_RESOURCE_VIDEO_SUCCESS = "DELETE_RESOURCE_VIDEO_SUCCESS";
export const DELETE_RESOURCE_VIDEO_FAILURE = "DELETE_RESOURCE_VIDEO_FAILURE";

export const READ_RESOURCE_VIDEO_REQUEST = "READ_RESOURCE_VIDEO_REQUEST";
export const READ_RESOURCE_VIDEO_SUCCESS = "READ_RESOURCE_VIDEO_SUCCESS";
export const READ_RESOURCE_VIDEO_FAILURE = "READ_RESOURCE_VIDEO_FAILURE";


// CareCell Videos
export const SAVE_CARECELL_VIDEO_REQUEST = "SAVE_CARECELL_VIDEO_REQUEST";
export const SAVE_CARECELL_VIDEO_SUCCESS = "SAVE_CARECELL_VIDEO_SUCCESS";
export const SAVE_CARECELL_VIDEO_FAILURE = "SAVE_CARECELL_VIDEO_FAILURE";

export const UPDATE_CARECELL_VIDEO_REQUEST = "UPDATE_CARECELL_VIDEO_REQUEST";
export const UPDATE_CARECELL_VIDEO_SUCCESS = "UPDATE_CARECELL_VIDEO_SUCCESS";
export const UPDATE_CARECELL_VIDEO_FAILURE = "UPDATE_CARECELL_VIDEO_FAILURE";

export const DELETE_CARECELL_VIDEO_REQUEST = "DELETE_CARECELL_VIDEO_REQUEST";
export const DELETE_CARECELL_VIDEO_SUCCESS = "DELETE_CARECELL_VIDEO_SUCCESS";
export const DELETE_CARECELL_VIDEO_FAILURE = "DELETE_CARECELL_VIDEO_FAILURE";

export const READ_CARECELL_VIDEO_REQUEST = "READ_CARECELL_VIDEO_REQUEST";
export const READ_CARECELL_VIDEO_SUCCESS = "READ_CARECELL_VIDEO_SUCCESS";
export const READ_CARECELL_VIDEO_FAILURE = "READ_CARECELL_VIDEO_FAILURE";

// SERVICE VIDEOS
export const SAVE_SERVICE_VIDEO_REQUEST = "SAVE_SERVICE_VIDEO_REQUEST";
export const SAVE_SERVICE_VIDEO_SUCCESS = "SAVE_SERVICE_VIDEO_SUCCESS";
export const SAVE_SERVICE_VIDEO_FAILURE = "SAVE_SERVICE_VIDEO_FAILURE";

export const UPDATE_SERVICE_VIDEO_REQUEST = "UPDATE_SERVICE_VIDEO_REQUEST";
export const UPDATE_SERVICE_VIDEO_SUCCESS = "UPDATE_SERVICE_VIDEO_SUCCESS";
export const UPDATE_SERVICE_VIDEO_FAILURE = "UPDATE_SERVICE_VIDEO_FAILURE";

export const DELETE_SERVICE_VIDEO_REQUEST = "DELETE_SERVICE_VIDEO_REQUEST";
export const DELETE_SERVICE_VIDEO_SUCCESS = "DELETE_SERVICE_VIDEO_SUCCESS";
export const DELETE_SERVICE_VIDEO_FAILURE = "DELETE_SERVICE_VIDEO_FAILURE";

export const READ_SERVICE_VIDEO_REQUEST = "READ_SERVICE_VIDEO_REQUEST";
export const READ_SERVICE_VIDEO_SUCCESS = "READ_SERVICE_VIDEO_SUCCESS";
export const READ_SERVICE_VIDEO_FAILURE = "READ_SERVICE_VIDEO_FAILURE";

/* ======================= CAMPUS VIDEOS ======================= */

// SAVE
export const SAVE_CAMPUS_VIDEO_REQUEST = "SAVE_CAMPUS_VIDEO_REQUEST";
export const SAVE_CAMPUS_VIDEO_SUCCESS = "SAVE_CAMPUS_VIDEO_SUCCESS";
export const SAVE_CAMPUS_VIDEO_FAILURE = "SAVE_CAMPUS_VIDEO_FAILURE";

// UPDATE
export const UPDATE_CAMPUS_VIDEO_REQUEST = "UPDATE_CAMPUS_VIDEO_REQUEST";
export const UPDATE_CAMPUS_VIDEO_SUCCESS = "UPDATE_CAMPUS_VIDEO_SUCCESS";
export const UPDATE_CAMPUS_VIDEO_FAILURE = "UPDATE_CAMPUS_VIDEO_FAILURE";

// DELETE
export const DELETE_CAMPUS_VIDEO_REQUEST = "DELETE_CAMPUS_VIDEO_REQUEST";
export const DELETE_CAMPUS_VIDEO_SUCCESS = "DELETE_CAMPUS_VIDEO_SUCCESS";
export const DELETE_CAMPUS_VIDEO_FAILURE = "DELETE_CAMPUS_VIDEO_FAILURE";

// READ
export const READ_CAMPUS_VIDEO_REQUEST = "READ_CAMPUS_VIDEO_REQUEST";
export const READ_CAMPUS_VIDEO_SUCCESS = "READ_CAMPUS_VIDEO_SUCCESS";
export const READ_CAMPUS_VIDEO_FAILURE = "READ_CAMPUS_VIDEO_FAILURE";


//Team video
export const SAVE_TEAM_VIDEO_REQUEST = "SAVE_TEAM_VIDEO_REQUEST";
export const SAVE_TEAM_VIDEO_SUCCESS = "SAVE_TEAM_VIDEO_SUCCESS";
export const SAVE_TEAM_VIDEO_FAILURE = "SAVE_TEAM_VIDEO_FAILURE";

export const UPDATE_TEAM_VIDEO_REQUEST = "UPDATE_TEAM_VIDEO_REQUEST";
export const UPDATE_TEAM_VIDEO_SUCCESS = "UPDATE_TEAM_VIDEO_SUCCESS";
export const UPDATE_TEAM_VIDEO_FAILURE = "UPDATE_TEAM_VIDEO_FAILURE";

export const DELETE_TEAM_VIDEO_REQUEST = "DELETE_TEAM_VIDEO_REQUEST";
export const DELETE_TEAM_VIDEO_SUCCESS = "DELETE_TEAM_VIDEO_SUCCESS";
export const DELETE_TEAM_VIDEO_FAILURE = "DELETE_TEAM_VIDEO_FAILURE";

export const READ_TEAM_VIDEO_REQUEST = "READ_TEAM_VIDEO_REQUEST";
export const READ_TEAM_VIDEO_SUCCESS = "READ_TEAM_VIDEO_SUCCESS";
export const READ_TEAM_VIDEO_FAILURE = "READ_TEAM_VIDEO_FAILURE";


// Plan
export const SAVE_PLAN_REQUEST = "SAVE_PLAN_REQUEST";
export const SAVE_PLAN_SUCCESS = "SAVE_PLAN_SUCCESS";
export const SAVE_PLAN_FAILURE = "SAVE_PLAN_FAILURE";

export const UPDATE_PLAN_REQUEST = "UPDATE_PLAN_REQUEST";
export const UPDATE_PLAN_SUCCESS = "UPDATE_PLAN_SUCCESS";
export const UPDATE_PLAN_FAILURE = "UPDATE_PLAN_FAILURE";

export const DELETE_PLAN_REQUEST = "DELETE_PLAN_REQUEST";
export const DELETE_PLAN_SUCCESS = "DELETE_PLAN_SUCCESS";
export const DELETE_PLAN_FAILURE = "DELETE_PLAN_FAILURE";

export const READ_PLAN_REQUEST = "READ_PLAN_REQUEST";
export const READ_PLAN_SUCCESS = "READ_PLAN_SUCCESS";
export const READ_PLAN_FAILURE = "READ_PLAN_FAILURE";

export const READ_PLAN_CATEGORIES_REQUEST = "READ_PLAN_CATEGORIES_REQUEST";
export const READ_PLAN_CATEGORIES_SUCCESS = "READ_PLAN_CATEGORIES_SUCCESS";
export const READ_PLAN_CATEGORIES_FAILURE = "READ_PLAN_CATEGORIES_FAILURE";

// Day Plan
export const SAVE_DAYPLAN_REQUEST = "SAVE_DAYPLAN_REQUEST";
export const SAVE_DAYPLAN_SUCCESS = "SAVE_DAYPLAN_SUCCESS";
export const SAVE_DAYPLAN_FAILURE = "SAVE_DAYPLAN_FAILURE";

export const UPDATE_DAYPLAN_REQUEST = "UPDATE_DAYPLAN_REQUEST";
export const UPDATE_DAYPLAN_SUCCESS = "UPDATE_DAYPLAN_SUCCESS";
export const UPDATE_DAYPLAN_FAILURE = "UPDATE_DAYPLAN_FAILURE";

export const DELETE_DAYPLAN_REQUEST = "DELETE_DAYPLAN_REQUEST";
export const DELETE_DAYPLAN_SUCCESS = "DELETE_DAYPLAN_SUCCESS";
export const DELETE_DAYPLAN_FAILURE = "DELETE_DAYPLAN_FAILURE";

export const READ_DAYPLAN_REQUEST = "READ_DAYPLAN_REQUEST";
export const READ_DAYPLAN_SUCCESS = "READ_DAYPLAN_SUCCESS";
export const READ_DAYPLAN_FAILURE = "READ_DAYPLAN_FAILURE";

// TWG Plans
export const READ_TWG_PLANS_REQUEST = "READ_TWG_PLANS_REQUEST";
export const READ_TWG_PLANS_SUCCESS = "READ_TWG_PLANS_SUCCESS";
export const READ_TWG_PLANS_FAILURE = "READ_TWG_PLANS_FAILURE";


//circleusers
export const AVAILABLE_USERS_REQUEST = "AVAILABLE_USERS_REQUEST";
export const AVAILABLE_USERS_SUCCESS = "AVAILABLE_USERS_SUCCESS";
export const AVAILABLE_USERS_FAIL = "AVAILABLE_USERS_FAIL";

export const SAVE_USER_CIRCLE_REQUEST = "SAVE_USER_CIRCLE_REQUEST";
export const SAVE_USER_CIRCLE_SUCCESS = "SAVE_USER_CIRCLE_SUCCESS";
export const SAVE_USER_CIRCLE_FAIL = "SAVE_USER_CIRCLE_FAIL";

// ActionTypes.js
export const MY_CIRCLE_REQUESTS_REQUEST = "MY_CIRCLE_REQUESTS_REQUEST";
export const MY_CIRCLE_REQUESTS_SUCCESS = "MY_CIRCLE_REQUESTS_SUCCESS";
export const MY_CIRCLE_REQUESTS_FAIL = "MY_CIRCLE_REQUESTS_FAIL";

// ActionTypes.js
export const UPDATE_USER_CIRCLE_REQUEST = "UPDATE_USER_CIRCLE_REQUEST";
export const UPDATE_USER_CIRCLE_SUCCESS = "UPDATE_USER_CIRCLE_SUCCESS";
export const UPDATE_USER_CIRCLE_FAIL = "UPDATE_USER_CIRCLE_FAIL";
// ActionTypes.js
export const MY_CIRCLE_LIST_REQUEST = "MY_CIRCLE_LIST_REQUEST";
export const MY_CIRCLE_LIST_SUCCESS = "MY_CIRCLE_LIST_SUCCESS";
export const MY_CIRCLE_LIST_FAIL = "MY_CIRCLE_LIST_FAIL";

export const SAVE_PLAN_CHURCH_REQUEST = "SAVE_PLAN_CHURCH_REQUEST";
export const SAVE_PLAN_CHURCH_SUCCESS = "SAVE_PLAN_CHURCH_SUCCESS";
export const SAVE_PLAN_FAIL = "SAVE_PLAN_FAIL";

export const READ_PLAN_CHURCH_REQUEST = "READ_PLAN_CHURCH_REQUEST";
export const READ_PLAN_CHURCH_SUCCESS = "READ_PLAN_CHURCH_SUCCESS";
export const READ_PLAN_FAIL = "READ_PLAN_FAIL";

export const SAVE_DAY_PLAN_REQUEST = "SAVE_DAY_PLAN_REQUEST";
export const SAVE_DAY_PLAN_SUCCESS = "SAVE_DAY_PLAN_SUCCESS";
export const SAVE_DAY_PLAN_FAIL = "SAVE_DAY_PLAN_FAIL";

//groups
// store/ActionTypes.js
export const SAVE_GROUP_REQUEST = "SAVE_GROUP_REQUEST";
export const SAVE_GROUP_SUCCESS = "SAVE_GROUP_SUCCESS";
export const SAVE_GROUP_FAIL = "SAVE_GROUP_FAIL";

export const SAVE_GROUP_MEMBERS_REQUEST = "SAVE_GROUP_MEMBERS_REQUEST";
export const SAVE_GROUP_MEMBERS_SUCCESS = "SAVE_GROUP_MEMBERS_SUCCESS";
export const SAVE_GROUP_MEMBERS_FAIL = "SAVE_GROUP_MEMBERS_FAIL";

export const SAVE_GROUP_BIBLEPLAN_REQUEST = "SAVE_GROUP_BIBLEPLAN_REQUEST";
export const SAVE_GROUP_BIBLEPLAN_SUCCESS = "SAVE_GROUP_BIBLEPLAN_SUCCESS";
export const SAVE_GROUP_BIBLEPLAN_FAIL = "SAVE_GROUP_BIBLEPLAN_FAIL";
// Devotionals
export const SAVE_DEVOTIONAL_REQUEST = "SAVE_DEVOTIONAL_REQUEST";
export const SAVE_DEVOTIONAL_SUCCESS = "SAVE_DEVOTIONAL_SUCCESS";
export const SAVE_DEVOTIONAL_FAIL = "SAVE_DEVOTIONAL_FAIL";

export const SAVE_DEVOTIONAL_VIDEO_REQUEST = "SAVE_DEVOTIONAL_VIDEO_REQUEST";
export const SAVE_DEVOTIONAL_VIDEO_SUCCESS = "SAVE_DEVOTIONAL_VIDEO_SUCCESS";
export const SAVE_DEVOTIONAL_VIDEO_FAIL = "SAVE_DEVOTIONAL_VIDEO_FAIL";

export const SAVE_DEVOTIONAL_JOURNAL_REQUEST = "SAVE_DEVOTIONAL_JOURNAL_REQUEST";
export const SAVE_DEVOTIONAL_JOURNAL_SUCCESS = "SAVE_DEVOTIONAL_JOURNAL_SUCCESS";
export const SAVE_DEVOTIONAL_JOURNAL_FAIL = "SAVE_DEVOTIONAL_JOURNAL_FAIL";

export const SAVE_DEVOTIONAL_TESTIMONY_REQUEST = "SAVE_DEVOTIONAL_TESTIMONY_REQUEST";
export const SAVE_DEVOTIONAL_TESTIMONY_SUCCESS = "SAVE_DEVOTIONAL_TESTIMONY_SUCCESS";
export const SAVE_DEVOTIONAL_TESTIMONY_FAIL = "SAVE_DEVOTIONAL_TESTIMONY_FAIL";

export const SAVE_DEVOTIONAL_VERSE_REQUEST = "SAVE_DEVOTIONAL_VERSE_REQUEST";
export const SAVE_DEVOTIONAL_VERSE_SUCCESS = "SAVE_DEVOTIONAL_VERSE_SUCCESS";
export const SAVE_DEVOTIONAL_VERSE_FAIL = "SAVE_DEVOTIONAL_VERSE_FAIL";
// In ActionTypes.js
export const READ_DEVOTIONALS_REQUEST = 'READ_DEVOTIONALS_REQUEST';
export const READ_DEVOTIONALS_SUCCESS = 'READ_DEVOTIONALS_SUCCESS';
export const READ_DEVOTIONALS_FAIL = 'READ_DEVOTIONALS_FAIL';

// In ActionTypes.js
export const SAVE_GROUP_DEVOTIONALS_REQUEST = 'SAVE_GROUP_DEVOTIONALS_REQUEST';
export const SAVE_GROUP_DEVOTIONALS_SUCCESS = 'SAVE_GROUP_DEVOTIONALS_SUCCESS';
export const SAVE_GROUP_DEVOTIONALS_FAIL = 'SAVE_GROUP_DEVOTIONALS_FAIL';
// In ActionTypes.js
export const SAVE_GROUP_JOURNALS_REQUEST = 'SAVE_GROUP_JOURNALS_REQUEST';
export const SAVE_GROUP_JOURNALS_SUCCESS = 'SAVE_GROUP_JOURNALS_SUCCESS';
export const SAVE_GROUP_JOURNALS_FAIL = 'SAVE_GROUP_JOURNALS_FAIL';

// In ActionTypes.js
export const SAVE_GROUP_VIDEOS_REQUEST = 'SAVE_GROUP_VIDEOS_REQUEST';
export const SAVE_GROUP_VIDEOS_SUCCESS = 'SAVE_GROUP_VIDEOS_SUCCESS';
export const SAVE_GROUP_VIDEOS_FAIL = 'SAVE_GROUP_VIDEOS_FAIL';

export const SAVE_GROUP_CURRICULUMS_REQUEST = 'SAVE_GROUP_CURRICULUMS_REQUEST';
export const SAVE_GROUP_CURRICULUMS_SUCCESS = 'SAVE_GROUP_CURRICULUMS_SUCCESS';
export const SAVE_GROUP_CURRICULUMS_FAIL = 'SAVE_GROUP_CURRICULUMS_FAIL';

export const SAVE_GROUP_TESTIMONIES_REQUEST = 'SAVE_GROUP_TESTIMONIES_REQUEST';
export const SAVE_GROUP_TESTIMONIES_SUCCESS = 'SAVE_GROUP_TESTIMONIES_SUCCESS';
export const SAVE_GROUP_TESTIMONIES_FAIL = 'SAVE_GROUP_TESTIMONIES_FAIL';
// ActionTypes.js - Add these
export const READ_MY_GROUPS_REQUEST = "READ_MY_GROUPS_REQUEST";
export const READ_MY_GROUPS_SUCCESS = "READ_MY_GROUPS_SUCCESS";
export const READ_MY_GROUPS_FAIL = "READ_MY_GROUPS_FAIL";

//Testimonial
export const TESTIMONIAL_READ_REQUEST = "TESTIMONIAL_READ_REQUEST";
export const TESTIMONY_OF_THE_DAY_READ_REQUEST = "TESTIMONY_OF_THE_DAY_READ_REQUEST";
export const TESTIMONIAL_SAVE_REQUEST = "TESTIMONIAL_SAVE_REQUEST";
export const TESTIMONIAL_CATEGORY_SAVE_REQUEST = "TESTIMONIAL_CATEGORY_SAVE_REQUEST";
export const TESTIMONIAL_CATEGORY_READ_REQUEST = "TESTIMONIAL_CATEGORY_READ_REQUEST";
export const TESTIMONIAL_READ_TRENDING_REQUEST = "TESTIMONIAL_READ_TRENDING_REQUEST";
export const TESTIMONIAL_READ_LIKED_REQUEST = "TESTIMONIAL_READ_LIKED_REQUEST";
export const TESTIMONIAL_READ_BY_CATEGORY_REQUEST = "TESTIMONIAL_READ_BY_CATEGORY_REQUEST";
export const TESTIMONIAL_READ_INREVIEW_REQUEST = "TESTIMONIAL_READ_INREVIEW_REQUEST";
export const TESTIMONIAL_READ_APPROVED_REQUEST = "TESTIMONIAL_READ_APPROVED_REQUEST";
export const TESTIMONY_DELETE_REQUEST = "TESTIMONY_DELETE_REQUEST";

// Add these to your ActionTypes file
export const GET_CHURCH_USERS_REQUEST = "GET_CHURCH_USERS_REQUEST";
export const GET_CHURCH_USERS_SUCCESS = "GET_CHURCH_USERS_SUCCESS";
export const GET_CHURCH_USERS_FAIL = "GET_CHURCH_USERS_FAIL";

// Add these to your ActionTypes file
export const GET_NOTIFICATIONS_REQUEST = "GET_NOTIFICATIONS_REQUEST";
export const GET_NOTIFICATIONS_SUCCESS = "GET_NOTIFICATIONS_SUCCESS";
export const GET_NOTIFICATIONS_FAIL = "GET_NOTIFICATIONS_FAIL";

// Add this line to your ActionTypes.js file
export const SEND_NOTIFICATION_TO_ONE_REQUEST = "SEND_NOTIFICATION_TO_ONE_REQUEST";
export const SEND_NOTIFICATION_TO_ONE_SUCCESS = "SEND_NOTIFICATION_TO_ONE_SUCCESS";
export const SEND_NOTIFICATION_TO_ONE_FAIL = "SEND_NOTIFICATION_TO_ONE_FAIL";

export const SET_ADMIN_USER_PASSWORD_REQUEST = "SET_ADMIN_USER_PASSWORD_REQUEST";
export const SET_ADMIN_USER_PASSWORD_SUCCESS = "SET_ADMIN_USER_PASSWORD_SUCCESS";
export const SET_ADMIN_USER_PASSWORD_FAIL = "SET_ADMIN_USER_PASSWORD_FAIL";

export const RESYNC_USER_AUTH0_PROFILE_REQUEST = "RESYNC_USER_AUTH0_PROFILE_REQUEST";
export const RESYNC_USER_AUTH0_PROFILE_SUCCESS = "RESYNC_USER_AUTH0_PROFILE_SUCCESS";
export const RESYNC_USER_AUTH0_PROFILE_FAIL = "RESYNC_USER_AUTH0_PROFILE_FAIL";

export const LOOKUP_CMS_USER_BY_EMAIL_REQUEST = "LOOKUP_CMS_USER_BY_EMAIL_REQUEST";
export const LOOKUP_CMS_USER_BY_EMAIL_SUCCESS = "LOOKUP_CMS_USER_BY_EMAIL_SUCCESS";
export const LOOKUP_CMS_USER_BY_EMAIL_FAIL = "LOOKUP_CMS_USER_BY_EMAIL_FAIL";

export const GET_IMAGE_BASE64_REQUEST = "GET_IMAGE_BASE64_REQUEST";
export const GET_IMAGE_BASE64_SUCCESS = "GET_IMAGE_BASE64_SUCCESS";
export const GET_IMAGE_BASE64_FAILURE = "GET_IMAGE_BASE64_FAILURE";

// Day Plan Detail Types (ADD THESE)
export const SAVE_DAYPLAN_DETAIL_REQUEST = "SAVE_DAYPLAN_DETAIL_REQUEST";
export const SAVE_DAYPLAN_DETAIL_SUCCESS = "SAVE_DAYPLAN_DETAIL_SUCCESS";
export const SAVE_DAYPLAN_DETAIL_FAILURE = "SAVE_DAYPLAN_DETAIL_FAILURE";

export const UPDATE_DAYPLAN_DETAIL_REQUEST = "UPDATE_DAYPLAN_DETAIL_REQUEST";
export const UPDATE_DAYPLAN_DETAIL_SUCCESS = "UPDATE_DAYPLAN_DETAIL_SUCCESS";
export const UPDATE_DAYPLAN_DETAIL_FAILURE = "UPDATE_DAYPLAN_DETAIL_FAILURE";

// Add this line in your action types file
export const DELETE_DAYPLAN_DETAIL_REQUEST = "DELETE_DAYPLAN_DETAIL_REQUEST";
export const DELETE_DAYPLAN_DETAIL_SUCCESS = "DELETE_DAYPLAN_DETAIL_SUCCESS";
export const DELETE_DAYPLAN_DETAIL_FAILURE = "DELETE_DAYPLAN_DETAIL_FAILURE";

// ActionTypes.js
export const DELETE_GROUP_REQUEST = "DELETE_GROUP_REQUEST";
export const DELETE_GROUP_SUCCESS = "DELETE_GROUP_SUCCESS";
export const DELETE_GROUP_FAIL = "DELETE_GROUP_FAIL";

export const UPDATE_GROUP_REQUEST = "UPDATE_GROUP_REQUEST";
export const UPDATE_GROUP_SUCCESS = "UPDATE_GROUP_SUCCESS";
export const UPDATE_GROUP_FAIL = "UPDATE_GROUP_FAIL";

export const SAVE_YOUTUBE_PLAN_REQUEST = "SAVE_YOUTUBE_PLAN_REQUEST";
export const SAVE_YOUTUBE_PLAN_SUCCESS = "SAVE_YOUTUBE_PLAN_SUCCESS";
export const SAVE_YOUTUBE_PLAN_FAIL = "SAVE_YOUTUBE_PLAN_FAIL";

export const CHURCH_CURRICULUM_SAVE_REQUEST =
  "CHURCH_CURRICULUM_SAVE_REQUEST";

  export const CHURCH_CURRICULUM_DELETE_REQUEST =
  "CHURCH_CURRICULUM_DELETE_REQUEST";
  export const CHURCH_JOURNAL_SAVE_REQUEST =
  "CHURCH_JOURNAL_SAVE_REQUEST";

  // PRAYERS
export const READ_CHURCH_PRAYERS_REQUEST = "READ_CHURCH_PRAYERS_REQUEST";
export const READ_CHURCH_PRAYERS_SUCCESS = "READ_CHURCH_PRAYERS_SUCCESS";
export const READ_CHURCH_PRAYERS_FAIL = "READ_CHURCH_PRAYERS_FAIL";

export const READ_CHANNEL_PRAYERS_REQUEST = "READ_CHANNEL_PRAYERS_REQUEST";
export const READ_CHANNEL_PRAYERS_SUCCESS = "READ_CHANNEL_PRAYERS_SUCCESS";
export const READ_CHANNEL_PRAYERS_FAIL = "READ_CHANNEL_PRAYERS_FAIL";

export const READ_MINISTRY_PRAYERS_REQUEST = "READ_MINISTRY_PRAYERS_REQUEST";
export const READ_MINISTRY_PRAYERS_SUCCESS = "READ_MINISTRY_PRAYERS_SUCCESS";
export const READ_MINISTRY_PRAYERS_FAIL = "READ_MINISTRY_PRAYERS_FAIL";

// Plan Links
export const SAVE_PLANLINK_REQUEST = "SAVE_PLANLINK_REQUEST";
export const SAVE_PLANLINK_SUCCESS = "SAVE_PLANLINK_SUCCESS";
export const SAVE_PLANLINK_FAILURE = "SAVE_PLANLINK_FAILURE";

export const UPDATE_PLANLINK_REQUEST = "UPDATE_PLANLINK_REQUEST";
export const UPDATE_PLANLINK_SUCCESS = "UPDATE_PLANLINK_SUCCESS";
export const UPDATE_PLANLINK_FAILURE = "UPDATE_PLANLINK_FAILURE";

export const DELETE_PLANLINK_REQUEST = "DELETE_PLANLINK_REQUEST";
export const DELETE_PLANLINK_SUCCESS = "DELETE_PLANLINK_SUCCESS";
export const DELETE_PLANLINK_FAILURE = "DELETE_PLANLINK_FAILURE";

export const READ_PLANLINK_REQUEST = "READ_PLANLINK_REQUEST";
export const READ_PLANLINK_SUCCESS = "READ_PLANLINK_SUCCESS";
export const READ_PLANLINK_FAILURE = "READ_PLANLINK_FAILURE";

// Agreements - Active Read & Consent
export const READ_ACTIVE_AGREEMENTS_REQUEST = "READ_ACTIVE_AGREEMENTS_REQUEST";
export const READ_ACTIVE_AGREEMENTS_SUCCESS = "READ_ACTIVE_AGREEMENTS_SUCCESS";
export const READ_ACTIVE_AGREEMENTS_FAILURE = "READ_ACTIVE_AGREEMENTS_FAILURE";

export const SAVE_CONSENT_REQUEST = "SAVE_CONSENT_REQUEST";
export const SAVE_CONSENT_SUCCESS = "SAVE_CONSENT_SUCCESS";
export const SAVE_CONSENT_FAILURE = "SAVE_CONSENT_FAILURE";

// Agreements - Admin CRUD
export const READ_AGREEMENTS_REQUEST = "READ_AGREEMENTS_REQUEST";
export const READ_AGREEMENTS_SUCCESS = "READ_AGREEMENTS_SUCCESS";
export const READ_AGREEMENTS_FAILURE = "READ_AGREEMENTS_FAILURE";

export const SAVE_AGREEMENT_REQUEST = "SAVE_AGREEMENT_REQUEST";
export const SAVE_AGREEMENT_SUCCESS = "SAVE_AGREEMENT_SUCCESS";
export const SAVE_AGREEMENT_FAILURE = "SAVE_AGREEMENT_FAILURE";

export const UPDATE_AGREEMENT_REQUEST = "UPDATE_AGREEMENT_REQUEST";
export const UPDATE_AGREEMENT_SUCCESS = "UPDATE_AGREEMENT_SUCCESS";
export const UPDATE_AGREEMENT_FAILURE = "UPDATE_AGREEMENT_FAILURE";

export const DELETE_AGREEMENT_REQUEST = "DELETE_AGREEMENT_REQUEST";
export const DELETE_AGREEMENT_SUCCESS = "DELETE_AGREEMENT_SUCCESS";
export const DELETE_AGREEMENT_FAILURE = "DELETE_AGREEMENT_FAILURE";

// Agreements - Analytics
export const READ_CONSENT_ANALYTICS_REQUEST = "READ_CONSENT_ANALYTICS_REQUEST";
export const READ_CONSENT_ANALYTICS_SUCCESS = "READ_CONSENT_ANALYTICS_SUCCESS";
export const READ_CONSENT_ANALYTICS_FAILURE = "READ_CONSENT_ANALYTICS_FAILURE";

export const READ_CONSENT_USERS_REQUEST = "READ_CONSENT_USERS_REQUEST";
export const READ_CONSENT_USERS_SUCCESS = "READ_CONSENT_USERS_SUCCESS";
export const READ_CONSENT_USERS_FAILURE = "READ_CONSENT_USERS_FAILURE";

export const READ_CONSENT_ENTITY_ANALYTICS_REQUEST =
  "READ_CONSENT_ENTITY_ANALYTICS_REQUEST";
export const READ_CONSENT_ENTITY_ANALYTICS_SUCCESS =
  "READ_CONSENT_ENTITY_ANALYTICS_SUCCESS";
export const READ_CONSENT_ENTITY_ANALYTICS_FAILURE =
  "READ_CONSENT_ENTITY_ANALYTICS_FAILURE";

export const READ_CONSENT_ENTITY_DETAILS_REQUEST =
  "READ_CONSENT_ENTITY_DETAILS_REQUEST";
export const READ_CONSENT_ENTITY_DETAILS_SUCCESS =
  "READ_CONSENT_ENTITY_DETAILS_SUCCESS";
export const READ_CONSENT_ENTITY_DETAILS_FAILURE =
  "READ_CONSENT_ENTITY_DETAILS_FAILURE";

// Entity Content Analytics
export const READ_ENTITY_CONTENT_ANALYTICS_REQUEST =
  "READ_ENTITY_CONTENT_ANALYTICS_REQUEST";
export const READ_ENTITY_CONTENT_ANALYTICS_SUCCESS =
  "READ_ENTITY_CONTENT_ANALYTICS_SUCCESS";
export const READ_ENTITY_CONTENT_ANALYTICS_FAILURE =
  "READ_ENTITY_CONTENT_ANALYTICS_FAILURE";

export const READ_ENTITY_CONTENT_DETAILS_REQUEST =
  "READ_ENTITY_CONTENT_DETAILS_REQUEST";
export const READ_ENTITY_CONTENT_DETAILS_SUCCESS =
  "READ_ENTITY_CONTENT_DETAILS_SUCCESS";
export const READ_ENTITY_CONTENT_DETAILS_FAILURE =
  "READ_ENTITY_CONTENT_DETAILS_FAILURE";

export const READ_ENTITY_CONTENT_VIEWS_ANALYTICS_REQUEST =
  "READ_ENTITY_CONTENT_VIEWS_ANALYTICS_REQUEST";
export const READ_ENTITY_CONTENT_VIEWS_ANALYTICS_SUCCESS =
  "READ_ENTITY_CONTENT_VIEWS_ANALYTICS_SUCCESS";
export const READ_ENTITY_CONTENT_VIEWS_ANALYTICS_FAILURE =
  "READ_ENTITY_CONTENT_VIEWS_ANALYTICS_FAILURE";

export const READ_ENTITY_CONTENT_VIEWS_TRENDING_REQUEST =
  "READ_ENTITY_CONTENT_VIEWS_TRENDING_REQUEST";
export const READ_ENTITY_CONTENT_VIEWS_TRENDING_SUCCESS =
  "READ_ENTITY_CONTENT_VIEWS_TRENDING_SUCCESS";
export const READ_ENTITY_CONTENT_VIEWS_TRENDING_FAILURE =
  "READ_ENTITY_CONTENT_VIEWS_TRENDING_FAILURE";

export const READ_ENTITY_CONTENT_VIEWS_DETAILS_REQUEST =
  "READ_ENTITY_CONTENT_VIEWS_DETAILS_REQUEST";
export const READ_ENTITY_CONTENT_VIEWS_DETAILS_SUCCESS =
  "READ_ENTITY_CONTENT_VIEWS_DETAILS_SUCCESS";
export const READ_ENTITY_CONTENT_VIEWS_DETAILS_FAILURE =
  "READ_ENTITY_CONTENT_VIEWS_DETAILS_FAILURE";
